<template>
  <v-app id="inspire">
    <AdminHeader type="search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <AdminMenu/>
          <v-container class="col-10">
             
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Нормативы</div>
                  <div class="breadcrumb">Нормативы</div>
                  <v-progress-circular
                      v-if="isLoading"
                      color="green"
                      indeterminate
                      style="width:200px; height:200px; z-index:999; position:absolute; top:40%; left:35%;"
                    ></v-progress-circular>
                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet border-gray">
                  <v-tabs
                      id="horizontal_tabs"
                      v-model="normativeTab"
                      centered
                      height="40"
                  >
                    <v-tab v-for="item in normativeType" :key="item.id" class="ml-4">
                      {{ item.name }}
                    </v-tab>
                  </v-tabs>
                </v-sheet>
              </v-col>
              <!------------------------------------------------------------------------------------------------------------------------------------>
              <v-col>

                <v-tabs-items v-model="normativeTab">
                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title
                          class="d-flex justify-space-between align-center"
                          style="border-bottom: 1px solid #eeeeee;padding-bottom: 0px;"
                      >
                        <div class="report-1 filter">
                          <v-tabs
                              id="sub_tabs"
                              v-model="enterpriseTab"
                              centered
                              class="reports-tabs"
                              height="40"
                          >
                            <v-tab
                                v-for="item in enterpriseType"
                                :key="item.id"
                                class="ml-4 no-bg"
                                style="background-color: transparent !important;"
                            >
                              {{ item.name }}
                            </v-tab>
                          </v-tabs>
                        </div>
                      </v-card-title>
                      <v-tabs-items v-model="enterpriseTab">
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <v-btn
                                :to="{ name: 'Organization', params: {type: 'new'} }"
                                class="button__lighten"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>

                            <v-btn
                                class="button__danger ml-3"
                                v-if="selectedLine && selectedLine.id"
                                @click="deleteOrganization(selectedLine)"
                                style="margin: 0px 10px !important;"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              <span v-if="selectedLine.deletion">Снять пометку на удаление</span>
                              <span v-else>Удалить</span>
                            </v-btn>

                            <v-btn
                                class="button__lighten ml-3"
                                v-else
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              Удалить
                            </v-btn>

                          </v-card-title>


                          <v-data-table
                              :headers="headersOrganization"
                              :items="organizationList ? organizationList.organization : []"
                              item-key="id"
                              v-model="selectCashbox"
                              no-data-text="Ничего не найдено"
                              hide-default-footer
                              class="elevation-1"
                              disable-pagination
                          >
                     
                                    <template v-slot:item="{ item }">
                                      <tr
                                        @click="setNomenOrg(item)"
                                        @dblclick="goToRoute('organization', item)"
                                        :class="[
                                          { 
                                            'selected-row': new_organization_id === item.id,
                                            'active-row': selectedLine && selectedLine.id === item.id 
                                          }
                                        ]"
                                      >
                                        <td>
                                          {{ item.name }}
                                          <span v-if="item.deletion" style="font-weight: bold; color: red;">X</span>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                          {{ item.inn }}
                                        </td>
                                        <td>
                                          {{ item.kpp }}
                                        </td>
                                        <td>
                                          {{ item.fullname }}
                                        </td>
                                       
                                      </tr>
                                    </template>
                          </v-data-table>


                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <v-btn
                                class="button__lighten"
                                @click="dialogEnterprise = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                          </v-card-title>
                          <div class="scroll-table">
                            <table id="table-1" cellpadding="1" >
                              <thead>
                                <tr>
                                  <th></th>
                                  <th class="no-wrap">Наименование</th>
                                  <th colspan="2">Код</th>
                                </tr>
                              </thead>
                              <tbody>
                              <template v-if="departmentListDef && departmentListDef.length > 0">
                                <template v-for="line of departmentListDef">
                                  <tr class="parrent" :key="line.id">
                                    <td >
                                      <template v-if="line.list && line.list.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(line.id) }"
                                            @click="openChildren(line.id)"
                                        >
                                        </button>
                                      </template>
                                    </td>
                                    <td >{{ line.name }}</td>
                                    <td >{{ line.number }}</td>
                                  </tr>
                                  <template v-if="line.list && line.list.length > 0">
                                    <template v-for="children of line.list">
                                      <tr
                                          v-if="openParentLine.includes(line.id)"
                                          :key="children.id"
                                          :class="{ children: true, open: openParentLine.includes(line.id) }"
                                      >
                                        <td ></td>
                                        <td >{{ children.name }}</td>
                                        <td >{{ children.number }}</td>
                                      </tr>
                                    </template>
                                  </template>
                                </template>
                              </template>
                              </tbody>
                            </table>
                          </div>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <v-select
                                v-model="select_org"
                                :items="[]"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                hide-details
                                dense
                                required
                                color="#629F33"
                                background-color="#fff"
                                style="max-width: 300px !important;"
                            ></v-select>
                            <v-btn
                                class="ml-3 button__lighten"
                                @click="dialogRoom = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать помещение
                            </v-btn>
                            <v-btn
                                class="ml-3 button__lighten"
                                @click="dialogGroup = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать группу
                            </v-btn>
                          </v-card-title>
                          <div class="scroll-table">
                            <table id="table-1" cellpadding="1">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th class="no-wrap">Наименование</th>
                                  <th>Занятие</th>
                                  <th>Дежурство</th>
                                  <th>Аренда</th>
                                  <th>Занят. сотр.</th>
                                  <th>Занят. пом.</th>
                                  <th>Индекс</th>
                                  <th>Структурная единица</th>
                                  <th>Код</th>
                                </tr>
                              </thead>
                              <tbody>
                              <template v-if="reportData4.length > 0">
                                <template v-for="line of reportData4">
                                  <tr class="parrent" :key="'parrent-' + line.id">
                                    <td>
                                      <template v-if="line.childrens.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(line.id) }"
                                            @click="openChildren(line.id)"
                                        ></button>
                                      </template>
                                    </td>
                                    <td colspan="6">{{ line.name }}</td>
                                    <td>{{ line.index }}</td>
                                    <td>{{ line.org }}</td>
                                    <td>{{ line.code }}</td>
                                  </tr>
                                  <template v-if="line.childrens.length > 0">
                                    <template v-for="children of line.childrens">
                                      <tr
                                          v-if="openParentLine.includes(line.id)"
                                          :key="'children-' + children.id"
                                          :class="{ children: true, open: openParentLine.includes(line.id) }"
                                      >
                                        <td></td>
                                        <td colspan="6">
                                          {{ children.name }}
                                        </td>
                                        <td>{{ children.index }}</td>
                                        <td>{{ children.org }}</td>
                                        <td>{{ children.code }}</td>
                                      </tr>
                                      <template v-if="children.childrens.length > 0">
                                        <template v-for="subchildren of children.childrens">
                                          <tr
                                              v-if="openSubparentLine.includes(children.id)"
                                              :key="'subchildren-' + subchildren.id"
                                              :class="{ children: true, open: openSubparentLine.includes(children.id) }"
                                          >
                                            <td></td>
                                            <td>{{ subchildren.name }}</td>
                                            <td>{{ subchildren.lesson }}</td>
                                            <td>{{ subchildren.duty }}</td>
                                            <td>{{ subchildren.rent }}</td>
                                            <td>{{ subchildren.busyWorker }}</td>
                                            <td>{{ subchildren.busyLocation }}</td>
                                            <td>{{ subchildren.index }}</td>
                                            <td>{{ subchildren.org }}</td>
                                            <td>{{ subchildren.code }}</td>
                                          </tr>
                                        </template>
                                      </template>
                                    </template>
                                  </template>
                                </template>
                              </template>
                              </tbody>
                            </table>
                          </div>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                              style="justify-content:space-between;"
                          >
                            <div class="d-flex align-center">
                                <v-select
                                  v-model="chashbox_org_id"
                                  :items="organizationList ? organizationList.organization : []"
                                  item-text="name"
                                  item-value="id"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  hide-details
                                  dense
                                  required
                                  color="#629F33"
                                  background-color="#fff"
                                  style="max-width: 240px !important;"
                              ></v-select>
                              <v-btn
                                  class="button__lighten ml-3"
                                  @click="preCreateCashbox"
                              >
                                <v-icon small class="mr-2">mdi-plus</v-icon>
                                Создать кассу
                              </v-btn>
                            </div>

                            <div v-if="new_cashbox && new_cashbox.id">
                               <v-btn
                                v-if="!new_cashbox.flag_deletion"
                                  class="button__danger ml-3"
                                  @click="removeCashbox(true)"
                                  style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;"
                              >
                                Удалить
                              </v-btn>
                              <v-btn
                                  v-else
                                  class="button__danger ml-3"
                                  @click="removeCashbox(false)"
                                  style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;"
                              >
                                Снять пометку на удаление
                              </v-btn>

                            </div>
                        
                          </v-card-title>

                          <v-data-table
                              :headers="headersCashbox"
                              :items="cashbox_list_full"
                              no-data-text="Ничего не найдено"
                              hide-default-footer
                              disable-pagination
                              class="elevation-1"
                          >
                          <template v-slot:item="{ item }">
                                      <tr
                                        style="cursor:pointer;"
                                        @click="setNomenCashbox(item)"
                                        @dblclick="getCashboxDetail(item)"
                                        :class="[
                                          { 
                                            'active-row': selectedLine && selectedLine.id === item.id 
                                          }
                                        ]"
                                      >
                                        <td>
                                          {{ item.name }}
                                          <span v-if="item.flag_deletion" style="font-weight: bold; color: red;">X</span>
                                        </td>
                                        <td>
                                          {{ item.org.name }}
                                        </td>
                                        <!-- <td>
                                          {{ item.till_id }}
                                        </td> -->
                                      </tr>
                                    </template>
                          </v-data-table>


                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                              style="justify-content:space-between;"
                          >
                          <div class="d-flex align-center">
                              <v-select
                                  v-model="chashbox_org_id_terminal"
                                  :items="organizationList ? organizationList.organization : []"
                                  item-text="name"
                                  item-value="id"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  hide-details
                                  dense
                                  required
                                  color="#629F33"
                                  background-color="#fff"
                                  style="max-width: 240px !important;"
                              ></v-select>
                              <v-btn
                                  class="button__lighten ml-3"
                                  @click="preCreateTerminal(chashbox_org_id_terminal)"
                              >
                                <v-icon small class="mr-2">mdi-plus</v-icon>
                                Создать эквайринг
                              </v-btn>
                            </div>

                            <div v-if="new_terminal && new_terminal.id">
                               <v-btn
                                v-if="!new_terminal.deletion"
                                  class="button__danger ml-3"
                                  @click="removeTerminalObj(true)"
                                  style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;"
                              >
                                Удалить
                              </v-btn>
                              <v-btn
                                  v-else
                                  class="button__danger ml-3"
                                  @click="removeTerminalObj(false)"
                                  style="padding: 8px 20px !important; margin:0px !important; margin-left:10px;"
                              >
                                Снять пометку на удаление
                              </v-btn>

                            </div>

                          </v-card-title>
                        

                          <v-data-table
                        :headers="headersChooseAcquiring"
                        :items="terminals_list ? terminals_list : []"
                        item-key="id"
                        no-data-text="Ничего не найдено"
                        :hide-default-footer="true"
                              disable-pagination
                        class="elevation-1"
                    >
                        <template v-slot:item="{ item }">
                                      <tr
                                        @click="setTerminal2(item)"
                                        @dblclick="goToTerminal(item)"
                                        :class="[
                                          { 
                                            'active-row': selectedTerminalLineOne && selectedTerminalLineOne.id === item.id
                                          }
                                        ]"
                                      >
                                        <td>
                                          {{ item.name }}
                                          <span v-if="item.deletion" style="font-weight: bold; color: red;">X</span>
                                        </td>
                                        <td>
                                          {{ item.org.name }}
                                        </td>
                                        <td>
                                          {{item.type}}
                                        </td>
                                      </tr>
                                    </template>
                    </v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <v-btn
                                class="button__lighten ml-3"
                                @click="dialogSms = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                          </v-card-title>
                          <v-data-table
                              :headers="headersSms"
                              :items="sms"
                              no-data-text="Ничего не найдено"
                              hide-default-footer
                              class="elevation-1"
                          >
                          </v-data-table>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title
                          class="d-flex justify-space-between align-center"
                          style="border-bottom: 1px solid #eeeeee;padding-bottom: 0px;"
                      >
                        <div class="report-1 filter">
                          <v-tabs
                              id="sub_tabs"
                              v-model="counterpartyTab"
                              centered
                              class="reports-tabs"
                              height="40"
                          >
                            <v-tab
                                v-for="item in counterpartyType"
                                :key="item.id"
                                class="ml-4 no-bg"
                                style="background-color: transparent !important;"
                            >
                              {{ item.name }}
                            </v-tab>
                          </v-tabs>
                        </div>
                      </v-card-title>
                      <v-tabs-items v-model="counterpartyTab">
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <div>
                              <v-autocomplete
                                  :items="[]"
                                  item-value="client_id"
                                  item-text="name"
                                  placeholder="Поиск"
                                  no-data-text="Результатов не найдено"
                                  clearable
                                  color="#629F33"
                                  item-color="success"
                                  v-model="select"
                                  filled
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  class="rounded-lg"
                                  append-icon=""
                                  hide-details
                                  outlined
                                  dense
                                  background-color="white"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon>mdi-magnify</v-icon>
                                </template>
                              </v-autocomplete>
                            </div>
                            <v-btn
                                class="button__lighten ml-3"
                                @click="dialogCounterparty = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать контрагента
                            </v-btn>
                            <v-btn
                                class="button__lighten ml-3"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать группу
                            </v-btn>
                          </v-card-title>
                          <v-data-table
                              disable-sort
                              :headers="headersCounterparty"
                              :items="counterparties"
                              item-key="id"
                              sort-by="name"
                              group-by="category"
                              class="elevation-1"
                              show-group-by
                              hide-default-footer
                          >
                            <template v-slot:group.header="{items, isOpen, toggle}">
                              <th colspan="5">
                                <v-icon @click="toggle">
                                  {{ isOpen ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline' }}
                                </v-icon>
                                {{ items[0].category }}
                              </th>
                            </template>
                          </v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <v-btn
                                class="button__lighten ml-3"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                            <v-btn
                                class="button__lighten ml-3"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать группу
                            </v-btn>
                          </v-card-title>
                          <v-data-table
                              disable-sort
                              :headers="headersSegments"
                              :items="segments"
                              item-key="id"
                              sort-by="name"
                              group-by="category"
                              class="elevation-1"
                              show-group-by
                              hide-default-footer
                          >
                            <template v-slot:group.header="{items, isOpen, toggle}">
                              <th colspan="5">
                                <v-icon @click="toggle">
                                  {{ isOpen ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline' }}
                                </v-icon>
                                {{ items[0].category }}
                              </th>
                            </template>
                          </v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <v-btn
                                class="button__lighten ml-3"
                                @click="dialogAdvertisement = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                          </v-card-title>
                          <v-data-table
                              :headers="headersAdvertisements"
                              :items="advertisements"
                              item-key="id"
                              class="elevation-1"
                              hide-default-footer
                          >
                            <template v-slot:item.code="{ item }">
                              <div :class="'circle ' + item.code"></div>
                            </template>
                          </v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <v-btn
                                class="button__lighten ml-3"
                                @click="dialogChannel = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                          </v-card-title>
                          <v-data-table
                              :headers="headersChannels"
                              :items="channels"
                              item-key="id"
                              class="elevation-1"
                              hide-default-footer
                          >
                          </v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <div>
                              <v-autocomplete
                                  :items="[]"
                                  item-text="name"
                                  placeholder="Поиск"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  class="rounded-lg"
                                  append-icon=""
                                  hide-details
                                  outlined
                                  dense
                                  background-color="white"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon>mdi-magnify</v-icon>
                                </template>
                              </v-autocomplete>
                            </div>
                            <v-btn-toggle mandatory background-color="#FFFFFF" class="rounded-lg ml-5">
                              <v-btn>
                                Все
                              </v-btn>
                              <v-btn>
                                Выбранные
                              </v-btn>
                            </v-btn-toggle>
                            <v-btn
                                class="button__lighten ml-3"
                                @click="dialogAddTag = true"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                          </v-card-title>
                          <v-data-table
                              v-if="listTags"
                              :headers="headersTags"
                              :items="listTags.tags"
                              item-key="id"
                              item-value="name"
                              no-data-text="Ничего не найдено"
                              hide-default-footer
                              class="elevation-1"
                          >
                          </v-data-table>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <v-card-title
                          class="d-flex justify-space-between align-center"
                          style="border-bottom: 1px solid #eeeeee;padding-bottom: 0px;"
                      >
                        <div class="report-1 filter">
                          <v-tabs
                              id="sub_tabs"
                              v-model="nomenclatureTab"
                              centered
                              class="reports-tabs"
                              height="40"
                          >
                            <v-tab
                                v-for="item in nomenclatureType"
                                :key="item.id"
                                class="ml-4 no-bg"
                                style="background-color: transparent !important;"
                            >
                              {{ item.name }}
                            </v-tab>
                          </v-tabs>
                        </div>
                      </v-card-title>
                      <v-tabs-items v-model="nomenclatureTab">
                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                            <div>
                              <v-select
                                  v-model="selectnomenclatureCreateType"
                                  :items="nomenclatureFilterType"
                                  item-text="name"
                                  item-value="id"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  hide-details
                                  dense
                                  required
                                  color="#629F33"
                                  background-color="#fff"
                                  style="max-width: 240px !important;"
                                  @change="changeNomenCreate()"
                                  return-object
                              ></v-select>
                            </div>
                            <v-btn
                                class="button__lighten ml-3"
                                :to="{ name: 'CreateNomenclature', params: {type: 'АбонементЧленство', group_id:selectedLine ? selectedLine.id : null, group_name:selectedLine ? selectedLine.name : null } }"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                          
                            <v-btn
                                class="button__lighten ml-3"
                                @click="dialogNomenclatureGroup = true"
                            >
                              <v-icon small class="mr-2" >mdi-plus</v-icon>
                              Создать группу
                            </v-btn>

                            <!-- <div v-if="selectedLine" style="margin-left:10px;">
                              Выбрана группа: {{selectedLine.name}}
                            </div> -->

                          </v-card-title>
                          <div class="scroll-table">
                            <table id="table-1" cellpadding="1">
                              <thead>
                              <tr>
                                <th></th>
                                <th class="no-wrap">Наименование</th>
                                <th>Тип номенклатуры</th>
                                <th>Ед.</th>
                                <th>Подразделение</th>
                                <th>В продаже</th>
                                <th>Комментарий</th>
                                <th>Артикул</th>
                                <th>Код</th>
                              </tr>
                              </thead>
                              <tbody>
                              <template v-if="nomenclature_full_list && nomenclature_full_list.length > 0">
                                <template v-for="line of nomenclature_full_list">
                                  <tr :class="['parrent', { 'active-row': selectedLine && selectedLine.id === line.id }]" :key="line.id" @dblclick="detailNomenclature(line)" @click="setNomen(line)">
                                    <td>
                                      <template v-if="line.list && line.list.length > 0">
                                        <button
                                            :class="{ 'open-hide': true, open: openParentLine.includes(line.id) }"
                                            @click="openChildren(line.id)"></button>
                                      </template>
                                    </td>
                                    <td style="cursor:pointer;" >
                                      {{ line.name }}
                                      <div v-if="line.flag_deletion" style="font-weight: bold; color: red;">X</div>
                                    </td>
                                        <td>{{ line.type }}</td>
                                        <td></td>
                                        <td>{{ line.department ? line.department.name : '' }}</td>
                                        <td>{{ line.onsale ? 'да' : 'нет' }}</td>
                                        <td>{{ line.comment }}</td>
                                        <td></td>
                                        <td>{{ line.vendor_code }}</td>
                                  </tr>
                                  <template v-if="line.list && line.list.length > 0">
                                    <template v-for="children of line.list">
                                      <tr v-if="openParentLine.includes(line.id)"
                                          :key="children.id"
                                          :class="{ children: true, open: openParentLine.includes(line.id),'active-row': selectedLine && selectedLine.id === children.id }" @dblclick="detailNomenclature(children)" @click="setNomen(children)">
                                          <!-- <td v-if="children.list && children.list.length > 0"></td> -->
                                          <td style="padding-left:30px;">
                                            <template v-if="children.list && children.list.length > 0">
                                              <button
                                                  :class="{ 'open-hide': true, open: openParentLine.includes(children.id) }"
                                                  @click="openChildren(children.id)"></button>
                                            </template>
                                          </td>
                                        <td style="cursor:pointer;" >
                                          {{ children.name }}
                                          <div v-if="children.flag_deletion" style="font-weight: bold; color: red;">X</div>
                                        </td>
                                        <td>{{ children.type }}</td>
                                        <td></td>
                                        <td>{{ children.department ? children.department.name : '' }}</td>
                                        <td>{{ children.onsale ? 'да' : 'нет' }}</td>
                                        <td>{{ children.comment }}</td>
                                        <td></td>
                                        <td>{{ children.vendor_code }}</td>
                                      </tr>

                                      <template v-if="children.list && children.list.length > 0">
                                        <template v-for="children2 of children.list">
                                          <tr v-if="openParentLine.includes(children.id)"
                                              :key="children2.id"
                                              :class="{ children: true, open: openParentLine.includes(children.id),'active-row': selectedLine && selectedLine.id === children2.id }" @dblclick="detailNomenclature(children2)" @click="setNomen(children2)">
                                            <td></td>
                                            <td style="cursor:pointer;" >
                                              {{ children2.name }}
                                              <div v-if="children2.flag_deletion" style="font-weight: bold; color: red;">X</div>
                                            </td>
                                            <td>{{ children2.type }}</td>
                                            <td></td>
                                            <td>{{ children2.department ? children2.department.name : '' }}</td>
                                            <td>{{ children2.onsale ? 'да' : 'нет' }}</td>
                                            <td>{{ children2.comment }}</td>
                                            <td></td>
                                            <td>{{ children2.vendor_code }}</td>
                                          </tr>
                                        </template>
                                      </template>


                                    </template>
                                  </template>
                                </template>

                              </template>
                              </tbody>
                            </table>


                          </div>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card-title
                              class="d-flex align-center"
                          >
                         
                            <v-btn
                                class="button__lighten ml-3"
                                @click="createNomenclatureSegmentDetail"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Создать
                            </v-btn>
                          
                            <!-- <v-btn
                                class="button__lighten ml-3"
                                @click="dialogNomenclatureGroup = true"
                            >
                              <v-icon small class="mr-2" >mdi-plus</v-icon>
                              Создать группу
                            </v-btn> -->

                            <v-btn
                                class="button__danger ml-3"
                                v-if="selectedLine && selectedLine.id"
                                @click="deleteNomenclatureSegment(selectedLine)"
                                style="margin: 0px 10px !important;"
                            >
                              <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              <span v-if="selectedLine.flag_deletion">Снять пометку на удаление</span>
                              <span v-else>Удалить</span>
                            </v-btn>
                            

                          </v-card-title>
                          <div class="scroll-table">
                            <table id="table-1" cellpadding="1">
                              <thead>
                              <tr>
                                <th class="no-wrap">Наименование</th>
                                <th>Тип</th>
                              </tr>
                              </thead>
                              <tbody>
                              <template v-if="nomenclature_segment_full_list && nomenclature_segment_full_list.length > 0">

                                <template v-for="line of nomenclature_segment_full_list">
                                  <tr style="cursor:pointer;" :class="['parrent', { 'active-row': selectedLine && selectedLine.id === line.id }]" :key="line.id" @dblclick="detailNomenclatureSegment(line)" @click="setNomenOrg(line)">
                               
                                        <td>{{ line.name }}
                                          <span v-if="line.flag_deletion" style="font-weight: bold; color: red;">X</span>
                                        </td>
                                        <td>{{ line.type }}</td>

                                  </tr>
                                </template>

                              </template>
                              </tbody>
                            </table>


                          </div>
                        </v-tab-item>

                        <!-- <v-tab-item>

                        </v-tab-item>
                        <v-tab-item>

                        </v-tab-item> -->

                      </v-tabs-items>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet class="rounded-lg border-gray">
                      <!-- <v-card-title class="d-flex justify-space-between align-center">
                        <div class="report-1 filter">
                          <v-sheet max-height="80px" rounded="lg" class="card tabs-sheet" style="width:100%;">
                            <v-tabs
                                id="horizontal_tabs"
                                v-model="reportSubShow"
                                centered
                                class="reports-tabs"
                                height="40"
                            >
                              <v-tab
                                  v-for="item in reportSubTypes[3]"
                                  :key="item.id"
                                  class="ml-4 no-bg"
                                  style="background-color: transparent !important;"
                              >
                                {{ item.name }}
                              </v-tab>
                            </v-tabs>
                          </v-sheet>
                        </div>
                      </v-card-title> -->
                      <Block :padding="0">
                        <div class="filtere">
                          <div class="top-line">
                            <div class="left">
                              <div class="w-352">
                                <v-autocomplete
                                    colspan="1"
                                    :items="[]"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск сотрудника"
                                    no-data-text="Результатов не найдено" clearable color="#629F33"
                                    item-color="success" v-model="select" filled
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined dense
                                    background-color="white"
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>
                                </v-autocomplete>
                              </div>
                              <v-btn class="search-button" style="margin-top: 0 !important;">
                                Новый сотрудник
                              </v-btn>
                            </div>
                            <div class="right">
                              <Grid :column="3" :gap="10" :customStyle="{ alignItems: 'center' }">
                                <span class="toggle-label">Выводить по</span>
                                <v-btn-toggle mandatory background-color="#FFFFFF" class="rounded-lg">
                                  <v-btn width="33%">
                                    10
                                  </v-btn>
                                  <v-btn width="33%">
                                    20
                                  </v-btn>
                                  <v-btn width="33%">
                                    30
                                  </v-btn>
                                </v-btn-toggle>
                                <v-btn class="filter-btn" @click="showFilterGrid = !showFilterGrid">
                                  <Icon :iconName="showFilterGrid ? 'x' : 'filter'" width=" 16" height="16"
                                        viewBox="0 0 16 16" strockeWidth="2" stroke="#fff"/>
                                  Фильтр
                                </v-btn>
                              </Grid>
                            </div>
                          </div>
                          <transition name="fade">
                            <div class="hidden-block" v-if="showFilterGrid">
                              <Grid :column="4" :gap="20" :customStyle="{ rowGap: 0 }">
                                <div class="filter__field">
                                                                    <span class="label">
                                                                        Название
                                                                    </span>
                                  <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                            item-value="value" item-text="title"
                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                            placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                  </v-select>
                                </div>
                                <div class="filter__field">
                                                                    <span class="label">
                                                                        Название
                                                                    </span>
                                  <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                            item-value="value" item-text="title"
                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                            placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                  </v-select>
                                </div>
                                <div class="filter__field">
                                                                    <span class="label">
                                                                        Название
                                                                    </span>
                                  <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                            item-value="value" item-text="title"
                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                            placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                  </v-select>
                                </div>
                                <div class="filter__field">
                                                                    <span class="label">
                                                                        Название
                                                                    </span>
                                  <v-select class="rounded-lg custom__select" :items="[]" item-title="title"
                                            item-value="value" item-text="title"
                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                            placeholder="Значение" append-icon="mdi-chevron-down" outlined dense>
                                  </v-select>
                                </div>
                                <div class="filter__field colspan-4 button-block">
                                  <v-btn class="apply">
                                    Применить
                                  </v-btn>
                                  <v-btn class="clear">
                                    Очистить
                                  </v-btn>
                                </div>

                              </Grid>
                            </div>
                          </transition>
                        </div>
                        <TableBlock :darkHeader="true" :notBorderBottom="true" :borderTop="true">
                          <template v-slot:head>
                            <tr>
                              <th class="font-bold">ФИО</th>
                              <th class="font-bold">Дата рождения</th>
                              <th class="font-bold">Должность</th>
                              <th class="font-bold">Код</th>
                            </tr>
                          </template>
                          <template v-slot:body>
                            <tr v-for="num in rows" :key="`row-${num}`">
                              <td class="no-wrap">
                                <div class="cliente">
                                  <div class="ava">
                                    <img src="/playground_assets/Image-2.png" alt="">
                                  </div>
                                  Иванов Иван Иванович
                                </div>
                              </td>
                              <td>
                                25.12.1999
                              </td>
                              <td>
                                Менеджер
                              </td>
                              <td>
                                121221323
                              </td>
                            </tr>

                          </template>
                        </TableBlock>
                        <div class="navigete">
                          <div class="information">
                            Показано с 1 по 10 из 64 результатов
                          </div>
                          <div class="pagination">
                            <transition name="fade">
                              <v-btn variant="text" class="pagination-btn-icon left" v-if="notShowFirstPage"
                                     @click="changeListPage('prev')">
                                <Icon iconName="chevron-left" width="24" height="24" viewBox="0 0 24 24"
                                      strocke="#629F33" strockeWidth="2"/>
                              </v-btn>
                            </transition>
                            <ul :class="{ 'list-end': listEnd }">
                              <li v-for="p in pageShow" :key="`page-number-${p}`">
                                <v-btn :class="{ 'pagination-btn': true, active: p == pageSelect }"
                                       @click="pageSelect = p">
                                  {{ p }}
                                </v-btn>
                              </li>
                              <li class="etc">
                                ...
                              </li>
                              <li>
                                <v-btn :class="{ 'pagination-btn': true, active: pageSelect == maxPage }"
                                       @click="pageSelect = maxPage">
                                  {{ maxPage }}
                                </v-btn>
                              </li>
                            </ul>
                            <v-btn variant="text" class="pagination-btn-icon" @click="changeListPage('next')">
                              <Icon iconName="chevron-left" width="24" height="24" viewBox="0 0 24 24"
                                    strocke="#629F33" strockeWidth="2"/>
                            </v-btn>
                          </div>
                        </div>
                      </Block>
                    </v-sheet>
                  </v-tab-item>

                  <v-tab-item>
                    <v-sheet class="rounded-lg">
          
                      <Block :padding="0">
                        <div class="filtere">
                          <div class="top-line">
                            <div class="left">
                              <div class="w-352">
                                <v-autocomplete
                                    colspan="1"
                                    :items="[]"
                                    item-value="client_id"
                                    item-text="name"
                                    placeholder="Поиск поступления"
                                    no-data-text="Результатов не найдено" clearable color="#629F33"
                                    item-color="success" v-model="select" filled
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    class="rounded-lg"
                                    append-icon=""
                                    hide-details
                                    outlined dense
                                    background-color="white"
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon>mdi-magnify</v-icon>
                                  </template>
                                </v-autocomplete>
                              </div>
                              <v-btn class="search-button" style="margin-top: 0 !important;" @click="goToStock">
                                Создать
                              </v-btn>
                            </div>
                            <div class="right">
                              <Grid :column="3" :gap="10" :customStyle="{ alignItems: 'center' }">
                                <span class="toggle-label">Выводить по</span>
                                <v-btn-toggle
                                    v-model="toggle_exclusive"
                                    mandatory
                                    background-color="#FFFFFF"
                                    class="mx-4 rounded-lg"
                                >
                                  <v-btn :value="10">
                                    10
                                  </v-btn>
                                  <v-btn :value="20">
                                    20
                                  </v-btn>
                                  <v-btn :value="30">
                                    30
                                  </v-btn>
                                </v-btn-toggle>
                                <v-btn class="filter-btn" @click="showFilterGrid = !showFilterGrid">
                                  <Icon :iconName="showFilterGrid ? 'x' : 'filter'" width=" 16" height="16"
                                        viewBox="0 0 16 16" strockeWidth="2" stroke="#fff"/>
                                  Фильтр
                                </v-btn>
                              </Grid>
                            </div>
                          </div>
                          <transition name="fade">
                            <div class="hidden-block" v-if="showFilterGrid">
                              <v-form
                            ref="receiptFilterForm"
                            v-model="valid_indiv"
                        >
                              <Grid :column="4" :gap="20" :customStyle="{ rowGap: 0 }">
                                <div class="filter__field">
                                  <span class="label">
                                    Название
                                  </span>
                                 <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="receiptFilter.name"
                                    :items="stockReceiptsDef"
                                    item-value="receipt.id"
                                    item-text="receipt.name"
                                    ref="selected"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>

                                </div>
                                <div class="filter__field">
                                  <span class="label">
                                    Номер
                                  </span>
                                 <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="receiptFilter.number"
                                    :items="stockReceiptsDef"
                                    item-value="number"
                                    item-text="number"
                                    ref="selected"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>

                                </div>
                                <div class="filter__field">
                                  <span class="label">
                                    Склад
                                  </span>
                                 <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="receiptFilter.stock"
                                    :items="stockReceiptsDef"
                                    item-value="stock.id"
                                    item-text="stock.name"
                                    ref="selected"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>

                                </div>
                                <div class="filter__field">
                                  <span class="label">
                                    Контрагент
                                  </span>
                                 <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="receiptFilter.supplier"
                                    :items="stockReceiptsDef"
                                    item-value="client.id"
                                    item-text="client.name"
                                    ref="selected"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>

                                </div>
                                <div class="filter__field colspan-8 button-block" style="margin-top:20px; display: flex;">
                                  <v-btn class="apply" @click="filterEvents(receiptFilter)">
                                    Применить
                                  </v-btn>
                                  <v-btn class="clear" @click="clearData" style="margin-left:10px;">
                                    Очистить
                                  </v-btn>
                                </div>

                              </Grid>
                              </v-form>
                            </div>
                          </transition>
                        </div>


                        <v-skeleton-loader
                      v-if="isLoading"
                      type="table"
                  >
                  </v-skeleton-loader>
                  <v-data-table
                      v-else
                      :headers="headersStockReceipts"
                      :items="stockReceiptsDef"
                      no-data-text="Результатов не найдено"
                      :items-per-page="toggle_exclusive"
                      :hide-default-footer="true"
                      :page="page"
                      item-key="client_id"
                      class="elevation-1"
                  >
                  <template v-slot:item.date="{ item }">
                    <router-link
                          :to="{ name: 'SaleStock', params: {stock_id: item.receipt.id, type: 'exist', stock_name: item.receipt.name}}"
                          class="d-flex"
                          style="align-items: center; text-decoration: none; color: #000"
                      >
                      {{ item.date }}
                      </router-link>
                  </template>
                    <template v-slot:item.number="{ item }">
                      <router-link
                          :to="{ name: 'SaleStock', params: {stock_id: item.receipt.id, type: 'exist', stock_name: item.receipt.name}}"
                          class="d-flex"
                          style="align-items: center; text-decoration: none; color: #000"
                      >
                        {{ item.number }}
                      </router-link>
                    </template>
                    <template v-slot:item.checked="{ item }">

                        <router-link
                          :to="{ name: 'SaleStock', params: {stock_id: item.receipt.id, type: 'exist', stock_name: item.receipt.name}}"
                          class="d-flex"
                          style="align-items: center; text-decoration: none; color: #000"
                      >
                      {{ item.stock?.name ?? 'Летний бар' }}
                      </router-link>

                    </template>
                  </v-data-table>
                  <v-card-actions
                      class="d-flex justify-content-between"
                      style="padding: 20px !important;"
                  >
                    <template v-if="stockReceiptsDef">
                      <div>
                        <span class="desktopRegularLabel"><span>Показано с 1 по {{ toggle_exclusive }} из {{ stockReceiptsDef.length }} результатов</span></span>
                      </div>
                      <div>
                        <v-pagination
                            v-model="page"
                            circle
                            color="#629F33"
                            :length="stockReceiptsDef.length"
                            :total-visible="6"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-card-actions>

                      </Block>
                    </v-sheet>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogEnterprise"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Подразделения (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogEnterprise = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form @submit.prevent="createDepartment">
                        <v-row>
                          <v-col>
                            <v-col class="d-flex justify-center">
                              <v-btn-toggle
                                  v-model="organization.type"
                                  mandatory
                                  class="rounded-lg"
                              >
                                <v-btn style="padding: 12px 20px !important; background-color: #fff !important;">
                                  Юридическое лицо
                                </v-btn>
                                <v-btn style="padding: 12px 20px !important; background-color: #fff !important;">
                                  Физическое лицо
                                </v-btn>
                              </v-btn-toggle>
                            </v-col>
                            <v-text-field
                                v-model="department_item.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                            <v-text-field
                                v-model="department_item.full_name"
                                label="Полное наименование"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                            <v-text-field
                                v-model="department_item.inn"
                                label="ИНН"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                            <v-text-field
                                v-model="department_item.kpp"
                                label="КПП"
                                outlined
                                dense
                                style="height: 48px; margin: 10px 0"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogRoom"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Помещение (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogRoom = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="6">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <label>Вместимость (чел)</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Вместимость (чел)"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <label>Группа</label>
                            <v-select
                                class="rounded-lg"
                                v-model="organization.type"
                                :items="[]"
                                item-value="type_id"
                                item-text="type_name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Группа"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="6">
                            <label>Варианты использования</label>
                            <v-switch
                                v-model="roomType"
                                label="Проведение занятий"
                                style="height: 30px;"
                                color="#629F33"
                            ></v-switch>
                            <v-switch
                                v-model="roomType"
                                label="Аренда"
                                style="height: 30px;"
                                color="#629F33"
                            ></v-switch>
                          </v-col>
                          <v-col md="6">
                            <label>Контроль занятости</label>
                            <v-switch
                                v-model="roomType"
                                label="Контролировать помещение"
                                style="height: 30px;"
                                color="#629F33"
                            ></v-switch>
                            <v-switch
                                v-model="roomType"
                                label="Контролировать тренера"
                                style="height: 30px;"
                                color="#629F33"
                            ></v-switch>
                          </v-col>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogGroup"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Группа (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogGroup = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="12">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="12">
                            <label>Группа помещений</label>
                            <v-select
                                class="rounded-lg"
                                v-model="organization.type"
                                :items="[]"
                                item-value="type_id"
                                item-text="type_name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Группа помещений"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogCashbox"
                  persistent
                  max-width="1000px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Касса (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogCashbox = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="4">
                            <v-text-field
                                v-model="new_cashbox.cashbox_name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4">
                            <v-select
                                class="rounded-lg"
                                v-model="new_cashbox.cashbox_type"
                                :items="[{id:'ОперационнаяКасса',name:'Операционная касса'},{id:'КассаПредприятия',name:'Касса предприятия'}]"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Тип кассы"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col md="4">
                            <v-select
                                class="rounded-lg"
                                v-model="new_cashbox.org_id"
                                :items="organizationList ? organizationList.organization : []"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Организация"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="new_cashbox.cashbox_type && new_cashbox.cashbox_type === 'ОперационнаяКасса'">
                          <v-col md="8">
                            <v-switch
                                v-model="new_cashbox.cashbox_not_use"
                                label="Использовать фискальный регистр"
                                style="height: 48px;"
                                color="#629F33"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row v-if="new_cashbox.cashbox_not_use && (new_cashbox.cashbox_type && new_cashbox.cashbox_type === 'ОперационнаяКасса')">
                          <v-col md="8">
                            <v-select
                                class="rounded-lg"
                                v-model="new_cashbox.cashbox_register_id"
                                :items="cashboxRegisterList ? cashboxRegisterList : []"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Фискальный регистр"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-if="new_cashbox.cashbox_not_use && (new_cashbox.cashbox_type && new_cashbox.cashbox_type === 'ОперационнаяКасса')">
                          <v-col md="8">
                            <v-text-field
                                v-model="new_cashbox.token_marking"
                                label="Токен"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="new_cashbox.cashbox_not_use && (new_cashbox.cashbox_type && new_cashbox.cashbox_type === 'ОперационнаяКасса')">
                          <v-col md="4">
                            <label>Информация по ККМ</label>
                            <v-select
                                class="rounded-lg"
                                v-model="new_cashbox.ffd"
                                :items="[
                                  {id:'1.0',name:'1.0'},
                                  {id:'1.0.5',name:'1.0.5'},
                                  {id:'1.1',name:'1.1'},
                                  {id:'1.2',name:'1.2'}
                                ]"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Версия ФФД"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col md="4">
                            <label>Номер ККМ</label>
                            <v-text-field
                                v-model="new_cashbox.maker_id"
                                label="Производитель"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4">
                            <v-text-field
                                v-model="new_cashbox.till_id"
                                label="Регистрационный"
                                outlined
                                dense
                                style="height: 48px; margin-top: 20px"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="6" v-if="new_cashbox.cashbox_not_use && (new_cashbox.cashbox_type && new_cashbox.cashbox_type === 'ОперационнаяКасса')">
                            <label>Эквайринговые терминалы</label>
                            <br>
                            <div class="acquiring-item" v-for="item in selected_terminals" :key="item.id">
                              <div class="acquiring-title">{{ item.name }}</div>
                              <v-btn icon @click="removeTerminal(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                            <v-btn
                                class="mt-3 button__lighten"
                                @click="getTerminals()"
                            >
                              <v-icon small class="mr-2">mdi-plus</v-icon>
                              Добавить
                            </v-btn>
                          </v-col>
                          <!-- <v-col md="12">
                            <v-switch
                                v-model="roomType"
                                label="Задавать вопрос о зачислении сдачи на лицевой счет"
                                style="height: 48px; margin-top: 10px"
                                color="#629F33"
                            ></v-switch>
                          </v-col> -->
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-space-between">
                            <!-- <v-btn
                                class="button__lighten"
                                @click="dialogHistoryCashbox = true"
                            >
                              <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                              История
                            </v-btn> -->
                            <div></div>
                            <div
                                v-if="new_cashbox.cashbox_id"
                                class="button button__success"
                                ref="activator"
                                style="cursor:pointer;"
                                @click="updateCashbox"
                            >
                              Изменить
                          </div>
                          <div
                                v-else
                                class="button button__success"
                                ref="activator"
                                style="cursor:pointer;"
                                @click="saveCashbox"
                            >
                              Сохранить
                          </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogListAcquiring"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <v-btn icon @click="dialogListAcquiring = false,selectedTerminalLines = {}">
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <div>
                      <h4>Эквайринговые терминалы</h4>
                    </div>
                    <v-btn icon @click="dialogListAcquiring = false,selectedTerminalLines = {}">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                                    
                  <v-data-table
                        :headers="headersChooseAcquiring"
                        :items="terminals_list ? terminals_list : []"
                        item-key="id"
                        no-data-text="Ничего не найдено"
                        :hide-default-footer="true"
                              disable-pagination
                        class="elevation-1"
                    >
                        <template v-slot:item="{ item }">
                                      <tr
                                        @click="setTerminal(item)"
                                        @dblclick="goToTerminal(item)"
                                        :class="[
                                          { 
                                            'active-row': selectedTerminalLines[item.id]
                                          }
                                        ]"
                                      >
                                        <td>
                                          {{ item.name }}
                                          <span v-if="item.deletion" style="font-weight: bold; color: red;">X</span>
                                        </td>
                                        <td>
                                          {{ item.type_bank }}
                                        </td>
                                        <td>
                                          {{selectedTerminalLines[item.id]}}
                                        </td>
                                      </tr>
                                    </template>
                    </v-data-table>

                  <v-card-actions class="py-5 d-flex justify-space-between">
                    <v-btn
                        class="button__lighten"
                        @click="preCreateTerminal"
                    >
                      <v-icon small class="mr-2">mdi-plus</v-icon>
                      Создать
                    </v-btn>
                
                    <v-btn
                        class="button button__success"
                        ref="activator"
                        type="submit"
                        :disabled="selected_terminals.length === 0"
                        @click="dialogListAcquiring = false, selectedTerminalLines = {}"
                    >
                      Выбрать
                    </v-btn>

                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogHistoryCashbox"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg" class="pb-5">
                  <v-card-title class="justify-space-between">
                    <v-btn icon @click="dialogHistoryCashbox = false">
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <div>
                      <h4>История</h4>
                    </div>
                    <v-btn icon @click="dialogHistoryCashbox = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-data-table
                      :headers="headersHistoryCashbox"
                      :items="historyCashbox"
                      no-data-text="Ничего не найдено"
                      hide-default-footer
                      class="elevation-1"
                  >
                  </v-data-table>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogAcquiring"
                  persistent
                  max-width="1000px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4 v-if="new_terminal.terminal_id">Эквайринговый терминал {{new_terminal.terminal_name}} (просмотр)</h4>
                      <h4 v-else>Эквайринговый терминал  (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogAcquiring = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-col class="d-flex justify-center">
                          <v-btn-toggle
                              v-model="organization.type"
                              mandatory
                              class="rounded-lg"
                          >
                            <v-btn style="padding: 12px 20px !important; background-color: #fff !important;" @click="new_terminal.terminal_type = 'Торговый'">
                              Торговый
                            </v-btn>
                            <v-btn style="padding: 12px 20px !important; background-color: #fff !important;" disabled readonly>
                              Онлайн
                            </v-btn>
                          </v-btn-toggle>
                        </v-col>
                        <v-row>
                          <v-col md="4">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="new_terminal.terminal_name"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4">
                            <label>Эквайринг</label>
                            <v-select
                                class="rounded-lg"
                                v-model="new_terminal.bank_id"
                                :items="bank_list"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col md="4">
                            <v-text-field
                                v-model="new_terminal.commission"
                                label="Процент коммисс"
                                outlined
                                dense
                                style="height: 48px; margin-top: 20px"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="4">
                            <label>Организация</label>
                            <v-select
                                class="rounded-lg"
                                v-model="new_terminal.org_id"
                                :items="organizationList ? organizationList.organization : []"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Организация"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                                @change="checkOrgChosed(new_terminal.org_id)"
                            ></v-select>
                          </v-col>
                          <v-col md="4">
                            <v-select
                                class="rounded-lg"
                                v-model="new_terminal.bank_account"
                                :items="bank_account_list"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Счет для зачисления"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px; margin-top: 20px"
                            ></v-select>
                          </v-col>
                          <v-col md="4">
                            <v-select
                                class="rounded-lg"
                                v-model="new_terminal.personal_account"
                                :items="department_account_list"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Вид лицевого счет"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px; margin-top: 20px"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="4">
                            <label>Касса</label>
                            <v-select
                                class="rounded-lg"
                                v-model="new_terminal.cashboxes_id"
                                :items="cashbox_list_full"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Касса"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col md="4" v-if="!new_terminal.terminal_not_use">
                            <label>Оборудование</label>
                            <v-select
                                class="rounded-lg"
                                v-model="new_terminal.terminal_equipment_id"
                                :items="terminals_list ? terminals_list : []"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Терминал"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                          <v-col md="4">
                            <v-switch
                                v-model="new_terminal.terminal_not_use"
                                label="Без подключения"
                                style="height: 48px;"
                                color="#629F33"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col md="4">
                            <label>Дополнительно</label>
                            <v-select
                                class="rounded-lg"
                                v-model="organization.comment"
                                :items="[]"
                                item-value="type_id"
                                item-text="type_name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Наименование"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col class="d-flex justify-space-between">
                            <!-- <v-btn
                                class="button__lighten"
                                @click="dialogHistoryCashbox = true"
                            >
                              <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                              История
                            </v-btn> -->
                            <div
                                v-if="new_terminal.terminal_id"
                                class="button button__success"
                                ref="activator"
                                style="cursor: pointer;"
                                @click="updateNewTerminal()"
                            >
                              Изменить
                            </div>
                            <div
                                v-else
                                class="button button__success"
                                ref="activator"
                                style="cursor: pointer;"
                                @click="saveNewTerminal()"
                            >
                              Сохранить
                            </div>

                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogSms"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Сервис SMS-рассылки (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogSms = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="6">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <label>SMS сервис</label>
                            <v-select
                                class="rounded-lg"
                                v-model="organization.type"
                                :items="[]"
                                item-value="type_id"
                                item-text="type_name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="SMS сервис"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px;"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="6">
                            <label>Настройки сервиса</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Пользователь"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="6">
                            <v-select
                                class="rounded-lg"
                                v-model="organization.type"
                                :items="[]"
                                item-value="type_id"
                                item-text="type_name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Пароль"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                style="height: 48px; margin-top: 20px"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="12">
                            <v-text-field
                                v-model="organization.name"
                                label="Подпись"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="12">
                            <label>Информация</label>
                          </v-col>
                          <v-col md="12">
                            Версия: 157.123
                          </v-col>
                          <v-col md="12">
                            Хеликс SMS провайдер
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogCounterparty"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Контрагент (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogCounterparty = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="8">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4">
                            <v-switch
                                v-model="roomType"
                                label="Комитент"
                                style="height: 30px;"
                                color="#629F33"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="12">
                            <label>Полное наименование</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Полное наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="7">
                            <label>Тип контрагента</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Тип контрагента"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                          <v-col md="5">
                            <v-btn-toggle
                                v-model="organization.type"
                                mandatory
                                class="rounded-lg"
                                style="margin-top: 20px"
                            >
                              <v-btn>
                                Юр. лицо
                              </v-btn>
                              <v-btn>
                                Физ.лицо/ИП
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogAdvertisement"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Рекламный источник (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogAdvertisement = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="12">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogChannel"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Канал привлечения (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogChannel = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="12">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="organization.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <v-row justify="center">
              <v-dialog
                  v-model="dialogAddTag"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Теги (создание)</h4>
                    </div>
                    <v-btn icon @click="dialogAddTag = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form ref="tagAddForm" @submit.prevent="submitTag">
                        <v-row>
                          <v-col md="12">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="tag.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <button
                                class="button button__success"
                                ref="activator"
                                type="submit"
                            >
                              Сохранить
                            </button>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="dialogNomenclatureGroup"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Номенклатура (создание группы)</h4>
                    </div>
                    <v-btn icon @click="dialogNomenclatureGroup = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="12">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="nomenclature_group.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="12">
                            <label>Тип номенклатуры</label>
                            <v-select
                              v-model="nomenclature_group.type"
                              class="rounded-lg"
                              :items="nomenclatureCreateType" item-title="name" item-value="id"
                              item-text="name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              label="Тип"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              style="height: 48px; margin-top: 10px;"
                          ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="12">
                            <label>Подразделение</label>
                            <v-select
                              v-model="nomenclature_group.department_id"
                              class="rounded-lg"
                              :items="departmentListDef ? departmentListDef : []" item-title="name" item-value="id"
                              item-text="name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              label="Подразделение"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              style="height: 48px; margin-top: 10px;"
                          ></v-select>
                          </v-col>
                  
                        </v-row>
                        <v-row>
                          <v-col md="12">
                            <label>Группа номенклатуры</label>

                                    <v-btn
                                        v-if="!chosedNomenclature"
                                        class="button__lighten"
                                        style="width:100%;"
                                        @click="chosedNomenclature = null, nomenclatureModal = true"
                                    >
                                    Выбор номеклатуры
                                    </v-btn>

                                    <div v-else style="display:flex; align-items:center;">
                                      <v-text-field
                                          v-model="chosedNomenclature.name"
                                          label="Наименование"
                                          outlined
                                          dense
                                          style="height: 48px;"
                                          class="rounded-lg"
                                      ></v-text-field>

                                      <div style="margin-left:10px; cursor: pointer; color:red;" @click="clearNomenclature()">
                                        X
                                      </div>
                                    </div>

                          </v-col>
                  
                        </v-row>
                        <v-row>
                          <v-col class="d-flex justify-end">
                            <div
                                class="button button__success"
                                style="cursor:pointer"
                                @click="saveNomenclatureGroup"
                            >
                              Сохранить
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row>
            <v-dialog
                  v-model="nomenclatureModal"
                  max-width="1000px"
                  style="padding:50px 20px;"
              >
                <v-card rounded="lg" v-if="nomenclatureModal">
                  <v-card-title class="justify-space-between">
                    <div style="text-align:center; "> 
                      <h3>Номенклатура (группы)</h3>
                    </div>
                    <div>
                    </div>
                    <v-btn icon @click="nomenclatureModal = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
            
            <div style="display:flex; flex-direction: column; border:1px solid #eee; width:100%; margin:10px 0px; padding:10px;">

              <div style="display:flex; align-items: center;">
                <v-text-field
                      v-model="searchService"
                      hide-details
                      dense
                      required
                      label="Поиск номенклатуры"
                      outlined
                      style="font-weight: 400; font-size: 16px; line-height: 24px;"
                      background-color="white"
                      color="#629F33"
                      class="search-service"
                      @input="handleSearch"
                  >                            

                    <template v-slot:prepend-inner>
                      <v-icon>mdi-magnify</v-icon>
                    </template>
                  </v-text-field>


                  <div style="display:flex; align-items: center;">
                      <div v-if="filter.nomenclature_id" style="cursor: pointer; color:red; margin-left:20px; margin-right: 10px;" @click="filter.nomenclature_id = null"> X </div>
                      <div v-if="filter.nomenclature_id">{{filter.nomenclature_id.name}}</div>
                  </div>
              </div>

              <template>
                <v-treeview
                v-if="nomenclature_full_list_def"
                    :items="nomenclature_full_list_def"
                    item-key="id"
                    item-text="name"
                    :search="searchService"
                    expand-icon="mdi-chevron-down"
                    item-children="list"
                    :filter="searchPackages"
                    ref="myTree"
                    activatable
                    color="warning"
                    return-object
                    selected-color="red"
                    @update:active="addToNomenclatureParent"
                    style="cursor:pointer;"
                >
                  <template v-slot:label="{ item, leaf }">
                    <v-list-item
                        class="service"
                        v-if="leaf"
                        :key="item.name"
                        @click="addToNomenclature(item)"
                    >
                      <v-list-item-title class="d-flex justify-space-between">
                        <span class="service-title">{{ item.name }} </span>
                        <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :key="item.name"
                        class="services"
                        v-else
                    >
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-treeview>
              </template>
          
              </div>
              <v-row>
                          <div style="margin-left: auto; padding:20px;">
                      
                            <button
                                class="button button__success"
                                style="font-weight: 500;font-size: 20px;"
                                @click="saveNomenclature"
                            >
                              Выбрать
                            </button>

                          </div>
                        </v-row>
            </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
          </v-row>

          <v-row justify="center">
              <v-dialog
                  v-model="segmentCreateDialog"
                  persistent
                  max-width="700px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Сегмент номенклатуры</h4>
                    </div>
                    <v-btn icon @click="segmentCreateDialog = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col md="12">
                            <label>Наименование</label>
                            <v-text-field
                                v-model="new_nomenclature_segment.name"
                                label="Наименование"
                                outlined
                                dense
                                style="height: 48px;"
                                class="rounded-lg"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col md="12">
                            <label>Тип</label>
                            <v-select
                              v-model="new_nomenclature_segment.type"
                              class="rounded-lg"
                              :items="[{id:'ФормироватьВручную',name:'Формировать Вручную'}]" item-title="name" item-value="id"
                              item-text="name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              label="Тип"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              style="height: 48px; margin-top: 10px;"
                          ></v-select>
                          </v-col>
                        </v-row>
                        
                       
                        <v-row>
                          <v-col class="d-flex justify-end">

                            <div
                                v-if="new_nomenclature_segment.id"
                                class="button button__success"
                                style="cursor:pointer"
                                @click="updateNomenclatureSegment"
                            >
                              Изменить
                            </div>
                            <div
                                v-else
                                class="button button__success"
                                style="cursor:pointer"
                                @click="saveNomenclatureSegment"
                            >
                              Сохранить
                            </div>

                            

                          </v-col>
                        </v-row>

                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
          

          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {globalMethods} from "@/mixins/globalMethods";
import AdminHeader from '@/components/Admin/AdminHeader.vue';
import AdminMenu from '@/components/Admin/AdminMenu.vue';
import {organizationActionTypes} from '@/store/modules/organization';
import {departmentActionTypes} from '@/store/modules/department';
import {getItem, setItem} from "@/helpers/persistanceStorage";
import {renewalActionTypes} from "@/store/modules/renewal";
import {mapState} from "vuex";
import {tagsActionTypes} from "@/store/modules/tags";
import {salesActionTypes} from "@/store/modules/sale";
import {nomenclatureActionTypes} from "@/store/modules/nomenclature";
import {cashboxActionTypes} from '@/store/modules/cashbox';
import {billActionTypes} from "@/store/modules/bill";
//import { VueDatePicker } from '@mathieustan/vue-datepicker';
//import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
//import Icon from '@/components/Icons.vue';

export default {
  name: 'AdminNormatives',
  props: ['new_organization_id'],
  mixins: [globalMethods],
  components: {
    AdminHeader,
    AdminMenu,
    //VueDatePicker,
    //Icon
  },
  watch: {
    normativeTab: function (val, oldValue) {
      console.log(this.normativeTab)
      if (val != oldValue) {
        this.$set(this, 'filter', {
          date: new Date(),
          client: null,
          uit: null,
          division: null
        })
        if(val === 4){
          this.$store.dispatch(departmentActionTypes.stockList)
                    .then((response) => {
                      if (response.success)
                        console.log(response)
                        this.stockReceiptsDef = response.stock
                        this.stockReceiptsDef2 = response.stock
            })
        }
        //this.$set(this, 'reportData', [])
        //this.$set(this, 'reportData2', [])
        //this.$set(this, 'reportData3', [])
        //this.$set(this, 'reportData4', [])
      }
    },
    reportSubShow: function (val, oldValue) {
      if (val != oldValue) {
        this.$set(this, 'filter', {
          date: new Date(),
          client: null,
          uit: null,
          division: null
        })
        this.$set(this, 'reportSubData', [])
        this.$set(this, 'reportSubData2', [])
        this.$set(this, 'reportSubData3', [])
        this.$set(this, 'reportSubData4', [])
      }
    },
    pageSelect: function (value) {
      if (value == 1) {
        this.$set(this, 'pageShow', [1, 2, 3, 4])
      } else if (value == this.maxPage) {

        let newShowPage = []
        for (let i = 1; i < 4; i++) {
          newShowPage.push(this.maxPage - i)
        }
        this.$set(this, 'pageShow', [1, ...newShowPage.reverse()])
      }
    },
    counterpartyTab() {
      if (this.counterpartyTab === 4) {
        this.$store.dispatch(tagsActionTypes.tagsList);
      }
    },
    chashbox_org_id() {
      console.log(this.chashbox_org_id)
      console.log('smeeen')
      this.getCashboxOrgList()
    },
    chashbox_org_id_terminal(){
      
      let testOrg = this.chashbox_org_id_terminal
      //this.new_cashbox.org_id

      this.$store.dispatch(cashboxActionTypes.getListTerminals, {
                org_id: testOrg
      }).then((resp) => {
            if(resp && resp.success) {
              this.terminals_list = resp.terminals
            } else {
              alert('Ошибка получения данных!')
            }
      })
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.cashbox.isLoading,
      isLoadingOrganization: state => state.organization.isLoading,
      organizationList: state => state.organization.list,
      departmentList: state => state.department.departmentList,
      listTags: state => state.tags.data,
      validationErrorsOrganization: state => state.organization.validationErrors,
    }),
    listEnd() {
      return this.pageSelect >= this.maxPage - 3 && this.pageShow[this.pageShow.length - 1] > 4
    },
    notShowFirstPage() {
      return this.pageShow[0] > 1 || this.pageShow[this.pageShow.length - 1] > 4
    },
    searchPackages() {
        let res = this.caseSensitive
          ? sayMyNane(item, search, textKey)
          : undefined

          function sayMyNane(item, search, textKey){
            (item[textKey2].indexOf(search) > -1)
          }

        return res

      }
  },
  data() {
    return {
      nomenclature_segment_full_list:[],
      segmentCreateDialog:false,
      new_nomenclature_segment:{
        name:null,
        type:"ФормироватьВручную"
      },
      chashbox_org_id_terminal:null,
      bank_account_list:[],
      cashbox_list_full:[],
      nomenclature_group:{
        name:null,
        department_id:null,
        group_id:null,
        type:null
      },
      normativeType: [
        {id: 0, name: 'Предприятия'},
        {id: 1, name: 'Контрагенты'},
        {id: 2, name: 'Номенклатура'},
        {id: 3, name: 'Персонал'},
        {id: 4, name: 'Поступления'}
      ],
      enterpriseType: [
        {id: 0, name: 'Организации'},
        {id: 1, name: 'Подразделения'},
        {id: 2, name: 'Помещения'},
        {id: 3, name: 'Кассы'},
        {id: 4, name: 'Эквайринговые терминалы'},
        {id: 5, name: 'Сервис SMS - рассылки'},
      ],
      counterpartyType: [
        {id: 0, name: 'Контрагенты'},
        {id: 1, name: 'Сегменты клиентов'},
        {id: 2, name: 'Рекламные источники'},
        {id: 3, name: 'Канал привлечения'},
        {id: 4, name: 'Теги'}
      ],
      // nomenclatureType: [
      //   {id: 0, name: 'Контрагенты'},
      //   {id: 1, name: 'Сегменты клиентов'},
      //   {id: 2, name: 'Рекламные источники'},
      //   {id: 3, name: 'Потенциальные клиенты'}
      // ],
      nomenclatureType: [
        {id: 0, name: 'Номенклатура'},
        {id: 1, name: 'Сегменты номенклатуры'}
      ],
      nomenclatureFilterType: [
        {id: 'all', name: 'Все'},
        {id: 'active', name: 'В продаже'},
        {id: 'notactive', name: 'Снят с продажи'}
      ],
      nomenclatureCreateType: [
        {id: 'Членство', name: 'Членство', link:'CreateNomenclature'},
        {id: 'Пакет', name: 'Пакет', link:'CreateNomenclaturePacket'},
        {id: 'Модификатор', name: 'Модификатор', link:'CreateNomenclatureModifier'},
        {id: 'Услуга', name: 'Услуга', link:'CreateNomenclatureService'},
        {id: 'Аренда', name: 'Аренда', link:'CreateNomenclatureRental'},
        {id: 'Блюдо', name: 'Блюдо', link:'CreateNomenclatureDish'},
        {id: 'Запас', name: 'Запас', link:'CreateNomenclatureStore'}
      ],
      reportSubTypes: [
        [
          {id: 0, name: 'Контрагенты'},
          {id: 1, name: 'Сегменты клиентов'},
          {id: 2, name: 'Интересы'},
          {id: 3, name: 'Рекламные источники'},
          {id: 4, name: 'Потенциальные клиенты'}
        ],
        [
          {id: 0, name: 'Номенклатура'},
          {id: 1, name: 'Сегменты номенклатуры'}
        ],
        [
          {id: 0, name: 'Сотрудники'},
          {id: 1, name: 'Должности'},
          {id: 2, name: 'Сегмент сотрудников'},
        ]
      ],
      normativeTab: 0,
      enterpriseTab: 0,
      counterpartyTab: 0,
      nomenclatureTab: 0,
      select_org: null,
      organization:{
        bank:{"type_id":1,"type_name":"Банк"},
        tax:{"type_id":1,"type_name":0},
        type:{"type_id":1,"type_name":"тест"},
        cashbox:{"type_id":1,"type_name":"Касса"},
        terminal:{"type_id":1,"type_name":"Оборудование"},
        bill:{"type_id":1,"type_name":"Счёт"},
        comment:{"type_id":1,"type_name":"Дополнительно"},
        code:""
      },
      headersOrganization: [
        {text: 'Наименование', align: 'start', value: 'name'},
        {text: 'Юр/физ лицо', align: 'start', value: 'inn'},
        {text: 'ИНН', align: 'start', value: 'inn'},
        {text: 'КПП', align: 'start', value: 'kpp'},
        {text: 'Полное наименование', align: 'start', value: 'fullname'},
      ],
      headersCashbox: [
        {text: 'Наименование', align: 'start', value: 'name', width: '40%'},
        {text: 'Организация', align: 'start', value: 'org.name', width: '40%'}
      ],
      headersAcquiring: [
        {text: 'Наименование', align: 'start', value: 'name'},
        {text: 'Эквайрер', align: 'start', value: 'acquiring'},
        {text: 'Касса', align: 'start', value: 'cashbox'},
        {text: 'Код', align: 'start', value: 'code'}
      ],
      headersChooseAcquiring: [
        {text: 'Наименование', align: 'start', value: 'name'},
        {text: 'Эквайринг', align: 'start', value: 'acquiring'},
        {text: 'Код', align: 'start', value: 'type'}
      ],
      chooseAcquirings: [
        {id: 1, name: 'Фитнес-регион HK (ПАО)', acquiring: 'Сбербанг'},
        {id: 2, name: 'Фитнес-регион HK (ПАО)', acquiring: 'Сбербанг'},
        {id: 3, name: 'Фитнес-регион HK (ПАО)', acquiring: 'Сбербанг'},
      ],
      headersHistoryCashbox: [
        {text: 'Дата', align: 'start', value: 'date'},
        {text: 'Сотрудник', align: 'start', value: 'user'},
        {text: 'История', align: 'start', value: 'history'}
      ],
      historyCashbox: [
        {date: '25.25.2999', user: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
        {date: '25.25.2999', user: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
        {date: '25.25.2999', user: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
      ],
      headersSms: [
        {text: 'Наименование', align: 'start', value: 'name'},
        {text: 'Пользователь', align: 'start', value: 'user'}
      ],
      sms: [
        {name: 'Название сервиса', user: 'Имя пользователя'}
      ],
      headersCounterparty: [
        {text: 'Наименование', align: 'start', value: 'name', group: false, sort: false},
        {text: 'Комментарий', align: 'start', value: 'comment', group: false, sort: false},
        {text: 'Дата регистр.', align: 'start', value: 'date_register', group: false, sort: false},
        {text: 'Сотрудник регистр.', align: 'start', value: 'user_register', group: false, sort: false},
        {text: 'Код', align: 'start', value: 'code', group: false, sort: false}
      ],
      counterparties: [
        {id: 1, name: 'Групповые', comment: '182748174817', date_register: '182748174817', user_register: '182748174817', code: '182748174817', category: 'Импорт клиентов'},
        {id: 2, name: 'Групповые', comment: '182748174817', date_register: '182748174817', user_register: '182748174817', code: '182748174817', category: 'Импорт клиентов'},
        {id: 3, name: 'Групповые', comment: '182748174817', date_register: '182748174817', user_register: '182748174817', code: '182748174817', category: 'Импорт клиентов'},
        {id: 4, name: 'Групповые', comment: '182748174817', date_register: '182748174817', user_register: '182748174817', code: '182748174817', category: 'Импорт клиентов'},
        {id: 5, name: 'Групповые', comment: '182748174817', date_register: '182748174817', user_register: '182748174817', code: '182748174817', category: 'Клиенты'},
        {id: 6, name: 'Групповые', comment: '182748174817', date_register: '182748174817', user_register: '182748174817', code: '182748174817', category: 'Клиенты'}
      ],
      headersSegments: [
        {text: 'Наименование', align: 'start', value: 'name', group: false, sort: false},
        {text: 'Дата создания', align: 'start', value: 'date', group: false, sort: false},
        {text: 'Способ формирования', align: 'start', value: 'format', group: false, sort: false},
        {text: 'Описание', align: 'start', value: 'description', group: false, sort: false},
        {text: 'Автор', align: 'start', value: 'user', group: false, sort: false}
      ],
      segments: [
        {id: 1, name: 'Групповые', date: '28.99.99', format: 'Формируется вручную', description: 'Описание', user: 'Безрукова Юлия Александровна', category: 'Сегменты клиентов'},
        {id: 2, name: 'Групповые', date: '28.99.99', format: 'Формируется вручную', description: 'Описание', user: 'Безрукова Юлия Александровна', category: 'Сегменты клиентов'},
        {id: 3, name: 'Групповые', date: '28.99.99', format: 'Формируется вручную', description: 'Описание', user: 'Безрукова Юлия Александровна', category: 'Сегменты клиентов'},
        {id: 4, name: 'Групповые', date: '28.99.99', format: 'Формируется вручную', description: 'Описание', user: 'Безрукова Юлия Александровна', category: 'Сегменты клиентов'},
        {id: 5, name: 'Групповые', date: '28.99.99', format: 'Формируется вручную', description: 'Описание', user: 'Безрукова Юлия Александровна', category: 'Клиенты'},
        {id: 6, name: 'Групповые', date: '28.99.99', format: 'Формируется вручную', description: 'Описание', user: 'Безрукова Юлия Александровна', category: 'Клиенты'}
      ],
      headersAdvertisements: [
        {text: 'Наименование', align: 'start', value: 'name', width: '90%'},
        {text: 'А', align: 'start', value: 'code', width: '10%'},
      ],
      advertisements: [
        {id: 1, name: 'Instagram', code: 'success'},
        {id: 2, name: 'WhatsApp', code: 'success'},
        {id: 3, name: 'Instagram', code: 'error'},
        {id: 4, name: 'WhatsApp', code: 'warning'},
      ],
      headersChannels: [
        {text: 'Наименование', align: 'start', value: 'name', width: '90%'},
        {text: 'Код', align: 'start', value: 'code', width: '10%'},
      ],
      channels: [
        {id: 1, name: 'Название канала', code: '00000123141'},
        {id: 2, name: 'Название канала', code: '00000123141'},
        {id: 3, name: 'Название канала', code: '00000123141'},
        {id: 4, name: 'Название канала', code: '00000123141'},
      ],
      headersTags: [
        {text: 'Теги', align: 'start', sortable: false, value: 'name'}
      ],
      tag: {
        name: null
      },
      cashbox: JSON.parse(getItem('list-cashbox')) ?? [],
      selectCashbox: null,
      selectAcquiring: [],
      showFilterGrid: false,
      rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      pageSelect: 1,
      pageShow: [1, 2, 3, 4],
      maxPage: 24,
      select: null,
      itemsStrucuUit: [
        {title: 'Клеверспорт Н. Челны', value: '1'},
        {title: 'Клеверспорт Москва', value: '2'},
        {title: 'Клеверспорт Санкт-Путербург', value: '3'},
      ],
      itemsClient: [
        {title: 'Ковалев А.Ю.', value: '1'},
        {title: 'Сидорова В.П.', value: '2'},
        {title: 'Самойлов К.И.', value: '3'},
      ],
      itemsDivision: [
        {title: 'Подразделение 1', value: '1'},
        {title: 'Подразделение 2', value: '2'},
        {title: 'Подразделение 3', value: '3'},
      ],
      reportSubShow: 0,
      filter: {
        date: new Date(),
        client: null,
        uit: null,
        division: null
      },
      buttonDisabled: false,
      reportDataDef: [
        {
          id: 1,
          name: 'Клуб 1',
          sale_count: 10,
          sale_price: 999999,
          return_count: 4,
          return_price: 534343,
          sale_return_count: 3,
          sale_return_price: 232323,
          payment: 232323,
          return_payment: 232323,
          payment_with_return: 232323,
          childrens: [
            {
              id: 2,
              name: 'Пакет 1',
              sale_count: 10,
              sale_price: 999999,
              return_count: 4,
              return_price: 534343,
              sale_return_count: 3,
              sale_return_price: 232323,
              payment: 232323,
              return_payment: 232323,
              payment_with_return: 232323,
            },
            {
              id: 3,
              name: 'Пакет 2',
              sale_count: 10,
              sale_price: 999999,
              return_count: 4,
              return_price: 534343,
              sale_return_count: 3,
              sale_return_price: 232323,
              payment: 232323,
              return_payment: 232323,
              payment_with_return: 232323,
            },
          ]
        },
        {
          id: 2,
          name: 'Клуб 1',
          sale_count: 10,
          sale_price: 999999,
          return_count: 4,
          return_price: 534343,
          sale_return_count: 3,
          sale_return_price: 232323,
          payment: 232323,
          return_payment: 232323,
          payment_with_return: 232323,
          childrens: []
        }
      ],
      reportData3: [
        {
          id: 1,
          name: 'Фитнес клуб',
          type: '182748174817',
          code: '000001231',
          childrens: [
            {
              id: 1,
              name: 'Услуга',
              type: '182748174817',
              ed: '1',
              depart: 'Отдел продаж',
              insale: '214',
              comment: 'Клмментарий',
              article: 'A34',
              code: '000001231',
            },
            {
              id: 2,
              name: 'Услуга 2',
              type: '182748174817',
              ed: '11',
              depart: 'Отдел продаж',
              insale: '14',
              comment: 'Клмментарий',
              article: 'A34',
              code: '000001231',
            },
            {
              id: 3,
              name: 'Услуга 3',
              type: '182748174817',
              ed: '2',
              depart: 'Отдел продаж',
              insale: '214',
              comment: 'Клмментарий',
              article: 'A34',
              code: '000001231',
            },
            {
              id: 4,
              name: 'Услуга 4',
              type: '182748174817',
              ed: '3',
              depart: 'Отдел продаж',
              insale: '214',
              comment: 'Клмментарий',
              article: 'A34',
              code: '000001231',
            },
          ]
        }
      ],
      reportData2: [
        {
          id: 1,
          name: 'Импорт клиентов',
          code: '13123123232321',
          childrens: [
            {
              id: 1,
              name: 'Персональные',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-01 12:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 2,
              name: 'Групповые',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-02 14:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 3,
              name: 'Персональные',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-01 12:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 4,
              name: 'Групповые',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-02 14:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
          ]
        },
        {
          id: 2,
          name: 'Клиенты',
          code: '13123123232321',
          childrens: [
            {
              id: 1,
              name: 'Персональные',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-01 12:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 2,
              name: 'Групповые',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-02 14:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 3,
              name: 'Персональные',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-01 12:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 4,
              name: 'Групповые',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-02 14:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
          ]
        },
        {
          id: 3,
          name: 'Импорт клиентов',
          code: '13123123232321',
          childrens: [
            {
              id: 1,
              name: 'Персональные',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-01 12:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 2,
              name: 'Групповые',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-02 14:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 3,
              name: 'Персональные',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-01 12:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
            {
              id: 4,
              name: 'Групповые',
              comment: 'Комментарий контрагента',
              register_date: '2023-07-02 14:00:20',
              register_employer: 'Сотрудник',
              code: '13123123232321',
            },
          ]
        },
      ],
      reportData: [
        {
          id: 1,
          name: 'КлвеверСпорт 1',
          code: 11314543351312320,
          childrens: [
            {
              id: 1,
              name: 'Групповые',
              code: 11314543351312320,
            },
            {
              id: 2,
              name: 'Персональные',
              code: 11314543351312320,
            },
            {
              id: 3,
              name: 'Групповые',
              code: 11314543351312320,
            },
            {
              id: 4,
              name: 'Персональные',
              code: 11314543351312320,
            },
          ]
        },
        {
          id: 2,
          name: 'КлвеверСпорт 2',
          code: 778314543351312320,
          childrens: [
            {
              id: 1,
              name: 'Групповые',
              code: 778314543351312320,
            },
            {
              id: 2,
              name: 'Персональные',
              code: 778314543351312320,
            },
            {
              id: 3,
              name: 'Групповые',
              code: 778314543351312320,
            },
            {
              id: 4,
              name: 'Персональные',
              code: 778314543351312320,
            },
          ]
        },
        {
          id: 3,
          name: 'КлвеверСпорт 3',
          code: 448314543351312320,
          childrens: [
            {
              id: 1,
              name: 'Групповые',
              code: 448314543351312320,
            },
            {
              id: 2,
              name: 'Персональные',
              code: 448314543351312320,
            },
            {
              id: 3,
              name: 'Групповые',
              code: 448314543351312320,
            },
            {
              id: 4,
              name: 'Персональные',
              code: 448314543351312320,
            },
          ]
        }
      ],
      reportData4: [
        {
          id: 1,
          name: 'КлвеверСпорт 1',
          index: 123,
          org: 'КлвеверСпорт Челны',
          code: 11314543351312320,
          childrens: [
            {
              id: 1,
              name: 'КлвеверСпорт 1',
              index: 123,
              org: 'КлвеверСпорт Челны',
              code: 11314543351312320,
              childrens: [
                {
                  id: 1,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
                {
                  id: 2,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
                {
                  id: 3,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
                {
                  id: 4,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
              ]
            }
          ]
        },
        {
          id: 2,
          name: 'КлвеверСпорт 1',
          index: 123,
          org: 'КлвеверСпорт Челны',
          code: 11314543351312320,
          childrens: [
            {
              id: 1,
              name: 'КлвеверСпорт 1',
              index: 123,
              org: 'КлвеверСпорт Челны',
              code: 11314543351312320,
              childrens: [
                {
                  id: 1,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
                {
                  id: 2,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
                {
                  id: 3,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
                {
                  id: 4,
                  name: 'КлвеверСпорт 1',
                  lesson: '+',
                  duty: '+',
                  rent: '+',
                  busyWorker: '+',
                  busyLocation: '+',
                  index: 123,
                  org: 'КлвеверСпорт Челны',
                  code: 11314543351312320,
                },
              ]
            }
          ]
        },
      ],
      reportSubData: [],
      reportSubData2: [],
      reportSubData3: [],
      reportSubData4: [],
      openParentLine: [],
      openSubparentLine: [],
      reportSubType: [
        {id: 0, name: 'Подразделения'},
        {id: 1, name: 'Помещения'},
        {id: 2, name: 'Кассы'},
        {id: 3, name: 'Эквайринговые терминалы'},
        {id: 4, name: 'Сервис SMS - рассылки'},
      ],
      dialogEnterprise: false,
      dialogRoom: false,
      dialogGroup: false,
      dialogCashbox: false,
      dialogHistoryCashbox: false,
      dialogAcquiring: false,
      dialogListAcquiring: false,
      dialogSms: false,
      dialogCounterparty: false,
      dialogAdvertisement: false,
      dialogChannel: false,
      dialogAddTag: false,
      roomType: false,
      department_item:{
        "name":"",
        "full_name":"",
        "inn":"",
        "kpp":""
      },
      departmentListDef:null,
      bankDef:[
        {
          type_id:0,
          type_name:"Банк 1"
        },
        {
          type_id:1,
          type_name:"Банк 2"
        },
        {
          type_id:2,
          type_name:"Банк 3"
        },
        {
          type_id:3,
          type_name:"Банк 4"
        }
      ],
      companyDef:[
        {
          type_id:0,
          type_name:"OOO на Reception1_k1"
        },
        {
          type_id:1,
          type_name:"OOO на Reception1_k2"
        },
        {
          type_id:2,
          type_name:"OOO Фитнес Клевер"
        },
        {
          type_id:3,
          type_name:"ИП Сорокин"
        }
      ],
      billDef:[
        {
          type_id:0,
          type_name:"Счёт 18274810"
        },
        {
          type_id:1,
          type_name:"Счёт 16274811"
        },
        {
          type_id:2,
          type_name:"Счёт 18274822"
        },
        {
          type_id:3,
          type_name:"Счёт 17274833"
        }
      ],
      cashboxDef:[
        {
          type_id:0,
          type_name:"Касса № 18274810"
        },
        {
          type_id:1,
          type_name:"Касса № 16274811"
        },
        {
          type_id:2,
          type_name:"Касса № 18274822"
        },
        {
          type_id:3,
          type_name:"Касса № 17274833"
        }
      ],
      terminalDef:[
        {
          type_id:0,
          type_name:"Терминал № 18274810"
        },
        {
          type_id:1,
          type_name:"Терминал № 16274811"
        },
        {
          type_id:2,
          type_name:"Терминал № 18274822"
        },
        {
          type_id:3,
          type_name:"Терминал № 17274833"
        }
      ],
      acquirings: [
        {id: 1, name: 'Касса OOO на Reception1_k1', acquiring: 'Банк 1', cashbox: 'Касса №16614', code: '18274810'},
        {id: 2, name: 'Касса OOO на Reception1_k2', acquiring: 'Банк 2', cashbox: 'Касса №12314', code: '16274811'},
        {id: 3, name: 'Касса OOO Фитнес Клевер', acquiring: 'Банк 3 ', cashbox: 'Касса №44314', code: '18274822'},
        {id: 4, name: 'Касса ИП Сорокин', acquiring: 'Банк 4', cashbox: 'Касса №33314', code: '17274833'},
      ],
      stockReceiptsDef:[
        {
          "date": "2024-09-12T17:42:10",
          "number": "111111",
          "summ": 2,
          "deletion": false,
          "checked": true,
          "receipt": {
            "id": "2f6b9e78-7115-11ef-b3a6-6eae8b56243b",
            "name": "Поступление 1 от 12.09.2024 17:42 "
          },
          "user": {
            "id": "271b2f78-1d9e-11ef-8fce-d8bbc19ad39b",
            "name": "admin"
          },
          "client": {
            "id": "6abbe180-1e59-11ef-8fce-d8bbc19ad39b",
            "name": "Банк"
          }
        },
        {
          "date": "2024-09-12T17:42:10",
          "number": "22222",
          "summ": 100,
          "deletion": false,
          "checked": true,
          "receipt": {
            "id": "2f6b9e78-7115-11ef-b3a6-6eae8b56243b-2",
            "name": "Поступление 222 от 12.09.2024 17:42 "
          },
          "user": {
            "id": "271b2f78-1d9e-11ef-8fce-d8bbc19ad39b-2",
            "name": "Менеджер"
          },
          "client": {
            "id": "6abbe180-1e59-11ef-8fce-d8bbc19ad39b-2",
            "name": "Клевер"
          }
        }
      ],
      stockReceiptsDef2:[
        {
          "date": "2024-09-12T17:42:10",
          "number": "111111",
          "summ": 2,
          "deletion": false,
          "checked": true,
          "receipt": {
            "id": "2f6b9e78-7115-11ef-b3a6-6eae8b56243b",
            "name": "Поступление 1 от 12.09.2024 17:42 "
          },
          "user": {
            "id": "271b2f78-1d9e-11ef-8fce-d8bbc19ad39b",
            "name": "admin"
          },
          "client": {
            "id": "6abbe180-1e59-11ef-8fce-d8bbc19ad39b",
            "name": "Банк"
          },
          "stock": {
            "id": "6abbe180-1e59-11ef-8fce-d8bbc19ad39b66",
            "name": "Летний бар"
          }
        },
        {
          "date": "2024-09-12T17:42:10",
          "number": "22222",
          "summ": 100,
          "deletion": false,
          "checked": true,
          "receipt": {
            "id": "2f6b9e78-7115-11ef-b3a6-6eae8b56243b-2",
            "name": "Поступление 222 от 12.09.2024 17:42 "
          },
          "user": {
            "id": "271b2f78-1d9e-11ef-8fce-d8bbc19ad39b-2",
            "name": "Менеджер"
          },
          "client": {
            "id": "6abbe180-1e59-11ef-8fce-d8bbc19ad39b-2",
            "name": "Клевер"
          },
          "stock": {
            "id": "6abbe180-1e59-11ef-8fce-d8bbc19ad39b66-22",
            "name": "Клевер"
          }
        }
      ],
      toggle_exclusive: 10,
      headersStockReceipts: [
        {
          text: 'Дата',
          align: 'start',
          value: 'date'
        },
        {
          text: 'Номер',
          align: 'start',
          value: 'number'
        },
        {
          text: 'Контрагент',
          align: 'start',
          value: 'client.name'
        },
        {
          text: 'Сумма',
          align: 'start',
          value: 'summ'
        },
        {
          text: 'Склад',
          align: 'start',
          value: 'checked'
        },
        {
          text: 'Название',
          align: 'start',
          value: 'receipt.name'
        },
        {
          text: 'Автор',
          align: 'start',
          value: 'client.name'
        },
      ],
      page: 1,
      receiptFilter: {
        name: [],
        number: [],
        stock: [],
        supplier: []
      },
      selected:[],
      valid_indiv: true,
      selectnomenclatureCreateType:{id:'all',name:'Все'},
      selectnomenclatureCreateLink:null,
      nomenclature_full_list:[],
      dialogNomenclatureGroup:false,
      nomenclature_on_sale_list:[],
      nomenclature_not_on_sale_list:[],
      nomenclature_full_list_def:[],
      searchService:null,
      chosedNomenclature:null,
      caseSensitive:false,
      nomenclatureModal:false,
      nomenclature_full_list_group:[],
      selectedLine:null,
      chashbox_org_id:null,
      new_cashbox:{
        org_id:null,
        cashbox_name:null,
        cashbox_type:"ОперационнаяКасса",
        cashbox_not_use:true,
        cashbox_register_id:null,
        token_marking:null,
        ffd:null,
        till_id:null,
        acquiring_array:[]
      },
      cashboxRegisterList:[
        {
            "id": "0bf720f0-a4e5-11f0-b3a9-6eae8b56243b",
            "name": "'1С: Фискальный регистратор (эмулятор)'4"
        },
        {
            "id": "9e4e635d-886f-11ee-8131-6cae8b562436",
            "name": "атол 8820"
        },
        {
            "id": "3cedd953-8188-11f0-b3a9-6eae8b56243b",
            "name": "'АТОЛ:ККТ с передачей данных в ОФД 10.Х (ФФД 1.2)'"
        },
        {
            "id": "0454633d-a4e0-11f0-b3a9-6eae8b56243b",
            "name": "'ШТРИХ-М:ККТ с передачей данных в ОФД (ФФД 1.2)'"
        }
      ],
      terminals_list:[],
      new_terminal:{
        org_id:null,
        terminal_name:null,
        bank_id:null,
        bank_account:null,
        personal_account:null,
        terminal_type:"Торговый",
        commission:null,
        terminal_not_use:true,
        terminal_equipment_id:null,
        cashboxes_id:null
      },
      selected_terminals:[],
      selectedTerminalLines:{},
      selectedTerminalLineOne:null,
      bank_list:[],
      department_account_list:[]
    }
  },
  mounted() {

    console.log(getItem('admin_norm_type'))

    if(getItem('admin_norm_type') && getItem('admin_norm_type') !== null && getItem('admin_norm_type') !== undefined){
      
      if(getItem('admin_norm_type') === 'nomenclature'){
        this.normativeTab = 2
        setItem('admin_norm_type',null)
      }

    }

    this.fetchFeed()
  },
  methods: {
    saveNomenclatureSegment(){
      this.$store.dispatch(nomenclatureActionTypes.createNomenclatureSegments,this.new_nomenclature_segment
      ).then((response2) => {
        if (response2.success) {

          this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegments,{}
          ).then((response) => {
            if (response.success) {
              this.nomenclature_segment_full_list = response.nomenclature
            } else {
              alert('Ошибка выполнения запроса! ' + response.error)
            }
          })


          this.new_nomenclature_segment = {
            name:null,
            type:"ФормироватьВручную"
          }
          this.segmentCreateDialog = false
          
          
        } else {
          alert('Ошибка выполнения запроса! ' + response2.error)
        }
      })
    },
    updateNomenclatureSegment(){

      let updObj = this.new_nomenclature_segment
      updObj.nomenclature_segment_id = updObj.id

      this.$store.dispatch(nomenclatureActionTypes.createNomenclatureSegments,updObj
      ).then((response2) => {
        if (response2.success) {

          this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegments,{}
          ).then((response) => {
            if (response.success) {
              this.nomenclature_segment_full_list = response.nomenclature
            } else {
              alert('Ошибка выполнения запроса! ' + response.error)
            }
          })


          this.new_nomenclature_segment = {
            name:null,
            type:"ФормироватьВручную"
          }
          this.segmentCreateDialog = false
          
          
        } else {
          alert('Ошибка выполнения запроса! ' + response2.error)
        }
      })
    },
    deleteNomenclatureSegment(item){

      let updObj = item
      updObj.remove = true
      updObj.type = updObj.deletion ? false : true
      updObj.nomenclature_segment_id = updObj.id

      this.$store.dispatch(nomenclatureActionTypes.createNomenclatureSegments,updObj
      ).then((response2) => {
        if (response2.success) {

          this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegments,{}
          ).then((response) => {
            if (response.success) {
              this.nomenclature_segment_full_list = response.nomenclature
            } else {
              alert('Ошибка выполнения запроса! ' + response.error)
            }
          })


          this.new_nomenclature_segment = {
            name:null,
            type:"ФормироватьВручную"
          }
          this.segmentCreateDialog = false
          this.selectedLine = null          
          
        } else {
          alert('Ошибка выполнения запроса! ' + response2.error)
        }
      })
    },
    detailNomenclatureSegment(item){

      this.new_nomenclature_segment = item
      this.segmentCreateDialog = true

    },
    createNomenclatureSegmentDetail(){
      this.new_nomenclature_segment = {
            name:null,
            type:"ФормироватьВручную"
          }
          this.segmentCreateDialog = true
    },
    removeTerminalObj(remove_type){
      console.log(this.new_terminal)

      let removeObj = {}

      removeObj.id = this.new_terminal.id
      removeObj.remove = true
      removeObj.type = remove_type

      this.new_terminal.org_id = this.new_terminal.org.id

  
      this.$store.dispatch(cashboxActionTypes.createTerminals, removeObj).then((resp) => {
            if(resp && resp.success) {

              this.getTerminals2()

              this.new_terminal = {
                org_id:null,
                terminal_name:null,
                bank_id:null,
                bank_account:null,
                personal_account:null,
                terminal_type:"Торговый",
                commission:null,
                terminal_not_use:true,
                terminal_equipment_id:null,
                cashboxes_id:null
              }

            } else {
              alert('Ошибка получения данных!')
            }
      })

    },
    removeCashbox(remove_type){
      console.log(this.new_cashbox)

      let removeObj = {}

      removeObj.id = this.new_cashbox.id
      removeObj.remove = true
      removeObj.type = remove_type

  
      this.$store.dispatch(cashboxActionTypes.createCashbox, removeObj).then((resp) => {
            if(resp && resp.success) {

              this.chashbox_org_id = this.new_cashbox.org.id

              this.new_cashbox = {
                  org_id:null,
                  cashbox_name:null,
                  cashbox_type:null,
                  cashbox_not_use:true,
                  cashbox_register_id:null,
                  token_marking:null,
                  ffd:null,
                  till_id:null,
                  acquiring_array:[]
                }

              
              
              this.dialogAcquiring = false

            } else {
              alert('Ошибка получения данных!')
            }
      })

    },
    checkOrgChosed(org_id){
      console.log(this.new_terminal.org_id)
      if(!this.chashbox_org_id) {
        this.getCashboxOrgList(this.new_terminal.org_id)
      }
      if(org_id){
        this.getCashboxOrgList(this.new_terminal.org_id)
      }
    },
    goToTerminal(item){
      //this.new_terminal = item
      console.log(this.new_terminal)
      
      this.$store.dispatch(cashboxActionTypes.getListTerminals, {
        terminal_id: item.id,
        org_id:item.org.id
      }).then((resp) => {
            if(resp && resp.success) {
              this.new_terminal = resp.terminals
              this.dialogAcquiring = true
              this.new_terminal.org_id = resp.terminals.org.id
              this.new_terminal.personal_account = resp.terminals.personal_account.id
              this.new_terminal.cashboxes_id = resp.terminals.cashbox ? resp.terminals.cashbox.id : null
              this.new_terminal.bank_id = resp.terminals.bank ? resp.terminals.bank.id : null   

              this.checkOrgChosed(this.new_terminal.org_id)

            } else {
              alert('Ошибка получения данных!')
            }
      })

      
    },
    saveNewTerminal(){
      console.log(this.new_terminal)
      //this.new_terminal.bank_id = "f86274ff-d47c-11ed-8125-6cae8b562436"
      //this.new_terminal.personal_account = "a544e4d3-ef94-11ef-b3a9-6eae8b56243b"
      this.$store.dispatch(cashboxActionTypes.createTerminals, this.new_terminal).then((resp) => {
            if(resp && resp.success) {

              this.getTerminals2()

              this.new_terminal = {
                org_id:null,
                terminal_name:null,
                bank_id:null,
                bank_account:null,
                personal_account:null,
                terminal_type:"Торговый",
                commission:null,
                terminal_not_use:true,
                terminal_equipment_id:null,
                cashboxes_id:null
              }

              this.dialogAcquiring = false

            } else {
              alert('Ошибка получения данных!')
            }
      })
    },
    updateNewTerminal(){
      console.log(this.new_terminal)
      //this.new_terminal.bank_id = "f86274ff-d47c-11ed-8125-6cae8b562436"
      //this.new_terminal.personal_account = "a544e4d3-ef94-11ef-b3a9-6eae8b56243b"
      this.$store.dispatch(cashboxActionTypes.createTerminals, this.new_terminal).then((resp) => {
            if(resp && resp.success) {

              this.getTerminals2()

              this.new_terminal = {
                org_id:null,
                terminal_name:null,
                bank_id:null,
                bank_account:null,
                personal_account:null,
                terminal_type:"Торговый",
                commission:null,
                terminal_not_use:true,
                terminal_equipment_id:null,
                cashboxes_id:null
              }
              
              this.dialogAcquiring = false

            } else {
              alert('Ошибка получения данных!')
            }
      })
    },
    preCreateCashbox(){
      this.selected_terminals = []
      this.new_cashbox = {
                  org_id:null,
                  cashbox_name:null,
                  cashbox_type:"ОперационнаяКасса",
                  cashbox_not_use:true,
                  cashbox_register_id:null,
                  token_marking:null,
                  ffd:null,
                  till_id:null,
                  acquiring_array:[]
                }
      this.dialogCashbox = true
    },
    getCashboxDetail(item) {

      this.$store.dispatch(cashboxActionTypes.getListCashbox, {
        cashbox_id: item.id,
        org_id: item.org.id,
        full: true
      }).then((resp) => {
            if(resp && resp.success) {
              this.new_cashbox = resp.list
              this.new_cashbox.org_id = resp.list.org.id
              this.selected_terminals = resp.list.acquiring_array
              
              this.new_cashbox.cashbox_register_id = resp.list.cashbox_register.id
              this.new_cashbox.cashbox_not_use = !resp.list.cashbox_not_use
              this.dialogCashbox = true
            } else {
              alert('Ошибка получения данных!')
            }
      })

      

    },
    getTerminals2(){
   

      //let testOrg = "59115d1d-9052-11eb-810c-6eae8b56243b"
      let testOrg = this.new_terminal.org_id
      //this.new_cashbox.org_id

      this.$store.dispatch(cashboxActionTypes.getListTerminals, {
                org_id: testOrg
      }).then((resp) => {
            if(resp && resp.success) {
              this.terminals_list = resp.terminals
            } else {
              alert('Ошибка получения данных!')
            }
      })
    },
    getTerminals(){
      if(!this.new_cashbox.org_id){
        alert('Не выбрана организация!')
        return
      }

      //let testOrg = "59115d1d-9052-11eb-810c-6eae8b56243b"
      let testOrg = this.new_cashbox.org_id
      //this.new_cashbox.org_id

      this.$store.dispatch(cashboxActionTypes.getListTerminals, {
                org_id: testOrg
      }).then((resp) => {
            if(resp && resp.success) {
              this.terminals_list = resp.terminals
              this.dialogListAcquiring = true
            } else {
              alert('Ошибка получения данных!')
            }
      })
    },
    updateCashbox(){

        if(this.selected_terminals){
          for(let i = 0; i < this.selected_terminals.length; i++) {
            //console.log(this.selected_terminals[i])
            this.new_cashbox.acquiring_array.push(this.selected_terminals[i].id)
          }
        }
        
        this.$store.dispatch(cashboxActionTypes.createCashbox, 
          this.new_cashbox
        ).then((resp) => {
              if(resp && resp.success) {
                this.dialogCashbox = false

                //this.getCashboxOrgList(this.new_cashbox.org_id)
                this.chashbox_org_id = this.new_cashbox.org_id

                this.new_cashbox = {
                  org_id:null,
                  cashbox_name:null,
                  cashbox_type:null,
                  cashbox_not_use:true,
                  cashbox_register_id:null,
                  token_marking:null,
                  ffd:null,
                  till_id:null,
                  acquiring_array:[]
                }
                
              } else {
                alert('Ошибка получения данных!')
              }
        })

    },
    saveCashbox(){

        if(this.selected_terminals){
          for(let i = 0; i < this.selected_terminals.length; i++) {
            //console.log(this.selected_terminals[i])
            this.new_cashbox.acquiring_array.push(this.selected_terminals[i].id)
          }
        }
        
        this.$store.dispatch(cashboxActionTypes.createCashbox, 
          this.new_cashbox
        ).then((resp) => {
              if(resp && resp.success) {
                this.dialogCashbox = false

                //this.getCashboxOrgList(this.new_cashbox.org_id)
                this.chashbox_org_id = this.new_cashbox.org_id

                this.new_cashbox = {
                  org_id:null,
                  cashbox_name:null,
                  cashbox_type:null,
                  cashbox_not_use:true,
                  cashbox_register_id:null,
                  token_marking:null,
                  ffd:null,
                  till_id:null,
                  acquiring_array:[]
                }
                
              } else {
                alert('Ошибка получения данных!')
              }
        })

    },
    getCashboxOrgList(item_org_id){

      let testOrgId

      if(item_org_id){
        testOrgId = item_org_id
      } else {
        testOrgId = this.chashbox_org_id
      }
      
      this.$store.dispatch(cashboxActionTypes.getListCashbox, {
                org_id: testOrgId,
                full: true
          }).then((resp) => {
            if(resp && resp.success) {
              this.cashbox_list_full = resp.list
            } else {
              alert('Ошибка получения данных!')
            }
          })
    },
    deleteOrganization(item){
      let status = item.deletion ? false : true
      this.$store.dispatch(organizationActionTypes.organizationCreate,{org_id:item.id,remove:true,remove_type:status}
      ).then((response) => {
        if (response.success) {
          if(response.organization && response.organization.object_id){
            this.$store.dispatch(organizationActionTypes.organizationList, {full:true})
            this.selectedLine = null
          }
        }
      })
    },
    removeTerminal(item){
      if(this.selected_terminals.length > 1){
        this.selected_terminals.splice(this.selected_terminals.findIndex(n => n.id === item.id),1);
      }
    },
    setTerminal2(item){
      if(this.selectedTerminalLineOne && this.selectedTerminalLineOne.id === item.id){
          //this.selectedTerminalLines.splice(item.id,1);
          this.selectedTerminalLineOne = null
          this.new_terminal = {
                org_id:null,
                terminal_name:null,
                bank_id:null,
                bank_account:null,
                personal_account:null,
                terminal_type:"Торговый",
                commission:null,
                terminal_not_use:true,
                terminal_equipment_id:null,
                cashboxes_id:null
              }
        } else {
          this.selectedTerminalLineOne = item
          this.new_terminal = item
        }
    },
    setTerminal(item){
      if(this.selectedTerminalLines && this.selectedTerminalLines[item.id]){
          console.log('estj')
          //this.selectedTerminalLines.splice(item.id,1);
          delete this.selectedTerminalLines[item.id]
          this.selected_terminals.splice(this.selected_terminals.findIndex(n => n.id === item.id),1);
        } else {
          console.log('net')
          this.selectedTerminalLines[item.id] = item
          this.selected_terminals.push(item)
        }
        console.log(this.selected_terminals)
        console.log(this.selectedTerminalLines)
    },
    setNomenCashbox(item){
      console.log(item)
      if(this.selectedLine && this.selectedLine.id === item.id){
          this.selectedLine = null
          this.new_cashbox = {
                  org_id:null,
                  cashbox_name:null,
                  cashbox_type:null,
                  cashbox_not_use:true,
                  cashbox_register_id:null,
                  token_marking:null,
                  ffd:null,
                  till_id:null,
                  acquiring_array:[]
                }
        } else {
          this.selectedLine = item
          this.new_cashbox = item
        }
    },
    setNomenOrg(item){
      if(this.selectedLine && this.selectedLine.id === item.id){
          this.selectedLine = null
        } else {
          this.selectedLine = item
        }
    },
    setNomen(item){
      console.log(item)
      if(item.this_group){
        if(this.selectedLine && this.selectedLine.id === item.id){
          this.selectedLine = null
        } else {
          this.selectedLine = item
        }
        
      } else {
        this.selectedLine = null
      }
      
    },
    clearNomenclature(){
      this.chosedNomenclature = null
    },
     saveNomenclature(){

        console.log(this.chosedNomenclature)

        this.nomenclatureModal = false
        
      },
      addToNomenclatureParent(itemar){
       
     
        if(itemar.length === 0) {
          return;
        }

        if(!itemar[0].this_group){
          alert('Это не группа')
          return
        }

        this.chosedNomenclature = itemar[0]

      },  
      addToNomenclature(item){

        if(item.this_group){
          alert('Это не группа')
          return
        }

        this.chosedNomenclature = item
   
      },  
      handleSearch(input) {
     
        if (input && input.length >= 2) {
          this.$refs.myTree.updateAll(true)
        } else {
          this.$refs.myTree.updateAll(false)
        }

      },
    saveNomenclatureGroup(){

      if(this.chosedNomenclature) {
        this.nomenclature_group.group_id = this.chosedNomenclature.id
      }

      console.log(this.nomenclature_group)

      //this.new_nomenclature.visits_less_frequently_type = null

      this.$store.dispatch(nomenclatureActionTypes.saveNomenclature, {group:true,nomenclature:this.nomenclature_group}).then((response) => {
        if(response && response.success) {
          if(response.nomenclature && response.nomenclature.id){
              
              this.fetchFeed()
              this.dialogNomenclatureGroup = false
          }
        }
      });

    },
    goToRoute(type,item){
      if(type === 'organization'){
        this.$router.push({
          name: 'Organization',
          params: {
            organization_id: item.id
          }
        });
      }
    },
    changeNomenCreate(){

      console.log(this.selectnomenclatureCreateType)

      this.nomenclature_full_list = []

      if(this.selectnomenclatureCreateType.id === 'all'){
        this.nomenclature_full_list = this.nomenclature_full_list_def
      }
      if(this.selectnomenclatureCreateType.id === 'active'){
        this.nomenclature_full_list = this.nomenclature_on_sale_list
      }
      if(this.selectnomenclatureCreateType.id === 'notactive'){
        this.nomenclature_full_list = this.nomenclature_not_on_sale_list
      }

    },
    
    preCreateTerminal(org_id){

      this.new_terminal = {
        org_id:null,
        terminal_name:null,
        bank_id:null,
        bank_account:null,
        personal_account:null,
        terminal_type:"Торговый",
        commission:null,
        terminal_not_use:true,
        terminal_equipment_id:null,
        cashboxes_id:null
      }

      if(org_id) {
        this.getCashboxOrgList(this.chashbox_org_id_terminal)
        this.new_terminal.org_id = this.chashbox_org_id_terminal
      } else {
        this.getCashboxOrgList(this.new_cashbox.org_id)
        this.new_terminal.org_id = this.new_cashbox.org_id
      }
 
      this.dialogAcquiring = true

    },
    goToStock(){
      this.$router.push({
                                      name: 'SaleStock',
                                      params: {
                                        type: 'new'
                                      }
                                    });
    },
    clearData(){
      this.$refs.receiptFilterForm.reset();
      this.stockReceiptsDef = this.stockReceiptsDef2
    },
    filterEvents(filter) {
      console.log(filter)

      if(filter.name && filter.name.length > 0){
        this.stockReceiptsDef = this.stockReceiptsDef2.filter((item) => filter.name.includes(item.receipt.id));
      }
      if(filter.number && filter.number.length > 0){
        this.stockReceiptsDef = this.stockReceiptsDef2.filter((item) => filter.number.includes(item.number));
      }
      if(filter.stock && filter.stock.length > 0){
        this.stockReceiptsDef = this.stockReceiptsDef2.filter((item) => filter.stock.includes(item.stock.id));
      }
      if(filter.supplier && filter.supplier.length > 0){
        this.stockReceiptsDef = this.stockReceiptsDef2.filter((item) => filter.supplier.includes(item.client.id));
      }
    },
    collectData(selected){
        this.selected.push(selected)
        this.dialogButton = true;
    },
    changeListPage(type) {
            if (type == 'next') {
                let lastNumber = [...this.pageShow].pop()
                if (lastNumber == this.maxPage - 1) {
                    return false
                }
                let newShowPage = []
                if (lastNumber < this.maxPage - 4) {

                    for (let i = 1; i < 5; i++) {
                        newShowPage.push(++lastNumber)
                    }
                    this.$set(this, 'pageShow', newShowPage)
                } else {
                    for (let i = 1; i < 5; i++) {
                        newShowPage.push(this.maxPage - i)
                    }
                    this.$set(this, 'pageShow', newShowPage.reverse())
                }
            } else {
                let firstNumber = [...this.pageShow].shift(),
                    lastNumber = [...this.pageShow].pop()

                if (lastNumber - 3 != firstNumber) {
                    firstNumber = lastNumber - 2
                }
                if (firstNumber > 5) {
                    let newShowPage = []
                    for (let i = 1; i < 5; i++) {
                        newShowPage.push(--firstNumber)
                    }
                    newShowPage[newShowPage.length - 1] = 1
                    this.$set(this, 'pageShow', newShowPage.reverse())
                } else {
                    this.$set(this, 'pageShow', [1, 2, 3, 4])
                }
            }
    },
    handleClick(val){
      console.log('aquiCLik')
      console.log(val)
      this.organization.cashbox = {type_id:1,type_name:val.cashbox}
      this.organization.bank = {type_id:1,type_name:val.acquiring}
      this.organization.code = val.code
      this.organization.terminal = {type_id:1,type_name:val.name}
      this.organization.company = {type_id:1,type_name:val.name}
      this.organization.tax = 5
      this.organization.type = 0 
      this.dialogAcquiring = true
    },
    createDepartment (){ 
      console.log('createDep')
      this.$store.dispatch(departmentActionTypes.departmentCreate, {
          department_name: this.department_item.name,
          parent_id: "d0957b34-1024-11ec-8113-6cae8b562436"
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(departmentActionTypes.departmentList)
                .then((response) => {
                  if (response.success)
                    this.dialogEnterprise = false;
                    this.departmentListDef = response.department
                })
          }
        })
    },
    fetchFeed() {
      this.nomenclature_full_list = []
      this.nomenclature_full_list_def = []

      this.$store.dispatch(organizationActionTypes.organizationList, {full:true})
      this.$store.dispatch(departmentActionTypes.departmentList).then((result) => {
        if(result){
          console.log(result)
          this.departmentListDef = result.department
        }
      })

      this.$store.dispatch(salesActionTypes.getNomenclatureFull, {type:'segment'}).then((response) => {
          if(response && response.success) {
            this.nomenclature_full_list = response.nomenclature
            this.nomenclature_full_list_def = response.nomenclature

            function filterOnSale(arr,type,group) {
                return arr
                  .map(item => {
                    let newItem = { ...item };

                    // Если есть вложенные элементы, обрабатываем рекурсивно
                    if (newItem.list && Array.isArray(newItem.list)) {
                      newItem.list = filterOnSale(newItem.list);
                    }

                    // Проверяем, нужно ли оставить этот элемент
                    const hasOnSaleChild = newItem.list && newItem.list.length > 0;

                    if(group){  
                      if (hasOnSaleChild) {
                        return newItem;
                      }
                    } else {
                      if(type){ 
                        const isOnSale = !!newItem.on_sale;

                        if (isOnSale || hasOnSaleChild) {
                          return newItem;
                        }
                        
                      } else {
                        const isNotOnSale = newItem.hasOwnProperty('on_sale') ? newItem.on_sale === false : false;

                        if (isNotOnSale || hasOnSaleChild) {
                          return newItem;
                        }
                      }
                    }
          
                    return null; // удалить элемент
                  })
                  .filter(Boolean);
              }


              this.nomenclature_on_sale_list = filterOnSale(this.nomenclature_full_list,true)
              this.nomenclature_not_on_sale_list = filterOnSale(this.nomenclature_full_list,false)

              //this.nomenclature_full_list_group = filterOnSale(this.nomenclature_full_list,false,true)


            


          }
      });


      this.$store.dispatch(billActionTypes.getListBill,{
              bank_acc: true
      }).then((response2) => {
        if (response2.success) {
            this.bank_account_list = response2.list
        }
      })

      let testBankType = 'Поставщики'

      this.$store.dispatch(cashboxActionTypes.getListBanks, {
                type: testBankType,
      }).then((resp) => {
            if(resp && resp.success) {
              this.bank_list = resp.list
            } else {
              alert('Ошибка получения данных!')
            }
      })
      this.$store.dispatch(cashboxActionTypes.getListBanksAccounts, {}).then((resp) => {
            if(resp && resp.success) {
              console.log('bank acccounts')
              this.department_account_list = resp.list
            } else {
              alert('Ошибка получения данных!')
            }
      })
      
      this.$store.dispatch(nomenclatureActionTypes.getNomenclatureSegments,{}
      ).then((response) => {
        if (response.success) {
          this.nomenclature_segment_full_list = response.nomenclature
        } else {
          alert('Ошибка выполнения запроса! ' + response.error)
        }
      })
      
      

    },

    openChildren(id) {
      if (this.openParentLine.includes(id)) {
        this.$delete(this.openParentLine, this.openParentLine.indexOf(id))
      } else {
        this.$set(this, 'openParentLine', [...this.openParentLine, id])
      }
    },
    openSubchildren(id) {
      if (this.openSubparentLine.includes(id)) {
        this.$delete(this.openSubparentLine, this.openSubparentLine.indexOf(id))
      } else {
        this.$set(this, 'openSubparentLine', [...this.openSubparentLine, id])
      }
    },
    choseSubType(id) {
      this.reportSubType = this.reportSubTypes[id]
    },
    submitTag() {
      if (this.$refs.tagAddForm.validate()) {
        this.$store.dispatch(tagsActionTypes.tagsAdd, {
          name: this.tag.name
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(tagsActionTypes.tagsList)
                .then((response) => {
                  if (response.success)
                    this.dialogAddTag = false;
                })
          }
        })
      }
    },
    detailNomenclature(item){

      console.log(item)

      let linkAr = {
        'АбонементЧленство':'CreateNomenclature',
        'АбонементПакетУслуг':'CreateNomenclaturePacket',
        'Услуга':'CreateNomenclatureService',
        'МодификаторЧленствПакетов':'CreateNomenclatureModifier',
        'Аренда':'CreateNomenclatureRental',
        'Блюдо':'CreateNomenclatureDish',
        'Запас':'CreateNomenclatureStore'
      }

      if(linkAr[item.type]){

        let link = linkAr[item.type]

        this.$router.push({
                  name: link,
                  params: {
                    type: item.type,
                    nomenclature_id: item.id,
                    nomenclature_choosed:[item]
                  }
        });
      }
      
    }
  }
}
</script>
<style scoped lang="scss">

.circle {
  height: 16px;
  width: 16px;
  border-radius: 25px;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
}
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0!important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
  min-width: 64px !important;
}

.page-top {
  margin-bottom: 20px;
}

.column {
  &__item {
    padding: 12px 15px;
    color: #1A1A1A;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    background: #fff;

    &:not(:last-child) {
      border-bottom: 1px solid #E0E0E0;
    }

    &.heading {
      padding: 20px 15px;
      background: #F1F1F1;
      font-size: 16px;
      line-height: 24px;
    }
  }
}

.filter {
  &.report-1 {
    width: 100%;
    display: flex;
    align-items: center;

    .left {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .right {
    }
  }

  &.report-3 {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .item {
      width: 100%;

      .v-application .primary--text {
        color: #767676 !important;
        caret-color: #767676 !important;

      }
    }
  }
}

.custom__date-button {
  width: 180px;
  height: 23px;
  display: flex;
  padding: 7px;
  max-width: 180px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess) !important;
  font-size: 16px;
  line-height: 24px;
  color: #fff !important;
}

.special-light-button {
  box-shadow: none;
  border-radius: 12px;
  color: #1A1A1A;
  text-transform: none;
  font-size: 13px;
  line-height: 16px;

  img {
    margin-right: 9.33px;
  }
}

.border-gray {
  border: 1px solid #E0E0E0 !important;

}

.scroll-table {
  overflow-x: auto;
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
  scrollbar-width: thin;
  scrollbar-color: #E0E0E0 #fff;
  border-bottom: 1px solid #E0E0E0;

  &::-webkit-scrollbar {
    height: 12px;
    background: #E0E0E0;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #E0E0E0;
    border-radius: 8px;
    border: 2px solid #fff;
  }

  table {
    border-collapse: collapse;
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
    min-width: 100%;

    &#table-3 {
      min-width: 100%;

      .td-check {
        div {
          display: flex;
          align-items: center;

          svg {
            margin-right: 10px;
          }
        }
      }

      .td-client {
        div {
          white-space: nowrap;
          display: flex;
          align-items: center;

          .ava {
            width: 24px;
            min-width: 24px;
            max-width: 24px;
            height: 24px;
            min-height: 24px;
            max-height: 24px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 8px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
        }
      }
    }

    &#table-4 {
      width: 100%;
    }

    th {
      vertical-align: top;
    }

    th,
    td {
      background: #fff;
      padding: 10px 12px;
      text-align: left;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      color: #000000;
      border: 1px solid #E0E0E0 !important;

      &.font-bold {
        font-weight: bold;
      }

      &.no-wrap {
        white-space: nowrap;
      }

      &:first-child {
        border-left: 0 !important;
      }

      &:last-child {
        border-left: 0 !important;
      }

      .open-hide {
        border: 1px solid #1A1A1A;
        width: 12px;
        height: 12px;
        display: flex;
        justify-content: center;
        border-radius: 2px;

        &::after {
          content: "+";
          line-height: 12px;
        }

        &.open {
          align-items: center;

          &::after {
            content: "";
            display: block;
            height: 1px;
            background: #1A1A1A;
            width: 6px;
            border-radius: 1px;
            line-height: 10px;
          }
        }
      }
    }

    tbody {
      tr {
        &.parrent {
          td {
            background: #F1F1F1;
          }
        }

        &:last-child {
          td {
            border-bottom: 0 !important;
          }
        }
      }
    }
  }
}

.no-bg {
  background-color: transparent !important;
}

.filtere {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      flex: 1;
      display: flex;
      align-items: center;

      .v-input__slot {
        border-radius: 12px;
      }
    }

    .right {
      .v-input__slot {
        border-radius: 12px;
      }

      .toggle-label {
        display: block;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: right;
        width: 100%;
        color: #767676;
      }

      .v-btn-toggle {
        button {
          &:first-child {
            border-radius: 12px 0 0 12px;
          }

          &:last-child {
            border-radius: 0 12px 12px 0;
          }

          background: #fff !important;

          &::before {
            display: none;
          }
        }
      }
    }

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }
    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {
    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.cliente {
  display: flex;
  align-items: center;

  .ava {
    margin-right: 8px;
  }
}

.navigete {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .information {
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #767676;
  }

  .pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    ul {
      list-style: none;
      display: flex;
      align-items: center;
      margin-right: 29px;

      &.list-end {
        li {
          &.etc {
            order: 1;
          }
        }
      }

      li {
        &:not(:last-child) {
          margin-right: 29px;
        }

        &:nth-child(1) {
          order: 1;
        }

        &:nth-child(2) {
          order: 2;
        }

        &:nth-child(3) {
          order: 3;
        }

        &:nth-child(4) {
          order: 4;
        }

        &.etc {
          order: 5;
          -webkit-touch-callout: none;
          /* iOS Safari */
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }

        &:nth-child(6) {
          order: 6
        }

        .pagination-btn {
          width: 32px !important;
          max-width: 32px !important;
          min-width: 32px !important;
          height: 32px !important;
          max-height: 32px !important;
          min-height: 32px !important;
          background: #fff !important;
          box-shadow: none !important;
          font-family: 'Circe';
          font-style: normal;
          font-weight: 700;
          font-size: 13px;
          line-height: 16px;
          color: #629F33 !important;
          border-radius: 50%;

          &.active {
            color: #fff !important;
            background: #629F33 !important;
          }
        }
      }

    }

    .pagination-btn-icon {
      width: 24px !important;
      max-width: 24px !important;
      min-width: 24px !important;
      height: 24px !important;
      max-height: 24px !important;
      min-height: 24px !important;
      background: #fff !important;
      box-shadow: none !important;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 13px;
      line-height: 16px;
      color: #629F33 !important;
      border-radius: 50%;

      &.left {
        -moz-transform: scale(-1, -1);
        -o-transform: scale(-1, -1);
        -webkit-transform: scale(-1, -1);
        transform: scale(-1, -1);
      }

    }
  }
}
.acquiring-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  align-items: center;
  border-radius: 24px;
  background: #E0ECD6;
}
.v-data-table tbody tr:hover {
  background-color: #f5f5f5 !important;
  cursor: pointer;
}
.selected-row td{
  background-color: #e0f7fa !important; /* Цвет выбранной строки */
  transition: background-color 0.3s;
}

.active-row td {
  background-color: #bbdefb !important; /* светло-голубой */
}
#table-1 tbody tr.active-row {
  background-color: #bbdefb !important;
}

</style>